(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-article"] && !Shopify.designMode) return;
  try {
    
  // Table of contents: built from the rendered h2s so the labels always
  // match the document. Stays hidden when the article has fewer than two
  // h2 headings (a TOC of one entry is noise).
  document.querySelectorAll('[data-ves-article-toc]').forEach(function (toc) {
    var body = document.querySelector('[data-ves-article-body]');
    var list = toc.querySelector('[data-ves-article-toc-list]');
    if (!body || !list) return;
    var heads = body.querySelectorAll('h2');
    if (heads.length < 2) return;
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-asset-ribbon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-ves-ribbon]');
    roots.forEach(function (root) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var rowEls = [].slice.call(root.querySelectorAll('[data-ves-ribbon-row]'));
      if (!rowEls.length) return;

      var rows = rowEls.map(function (el) {
        var dir = parseInt(el.getAttribute('data-dir'), 10) || 1;
        var base = parseFloat(el.getAttribute('data-base')) || 0.4;
        return { el: el, x: 0, dir: dir, base: base, hw: 0 };
      });

      // Duplicate each row's cards once so a full set scrolls off seamlessly.
      rows.forEach(function (r) {
        var originals = [].slice.call(r.el.children);
        originals.forEach(function (node) {
          r.el.appendChild(node.cloneNode(true));
        });
      });

      function measure() {
        rows.forEach(function (r) {
          r.hw = r.el.scrollWidth / 2;
          r.x = r.dir < 0 ? -r.hw : 0;
          r.el.style.transform = 'translateX(' + r.x + 'px)';
        });
      }
      measure();
      window.addEventListener('resize', measure);

      if (reduce) return;

      var boost = 0;
      var lastScroll = window.scrollY;
      window.addEventListener('scroll', function () {
        var d = window.scrollY - lastScroll;
        lastScroll = window.scrollY;
        boost += d * 0.5;
        boost = Math.max(-60, Math.min(60, boost));
      }, { passive: true });

      function tick() {
        boost *= 0.9;
        rows.forEach(function (r) {
          r.x -= r.dir * (r.base + Math.abs(boost) * 0.04) + boost * 0.06 * r.dir;
          if (r.x <= -r.hw) r.x += r.hw;
          if (r.x > 0) r.x -= r.hw;
          r.el.style.transform = 'translateX(' + r.x + 'px)';
        });
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });

    var revealRoots = document.querySelectorAll('[data-ves-ribbon]');
    revealRoots.forEach(function (root) {
      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-in');
            io.disconnect();
          }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-built-for"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-ves-built-for]');
    if (!sections.length) return;

    var prefersReduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;

    function reveal(el) {
      el.classList.add('is-in');
    }

    sections.forEach(function (section) {
      // In the theme editor or with reduced motion, instant-complete so no
      // content stays hidden.
      if (prefersReduced || designMode || !('IntersectionObserver' in window)) {
        reveal(section);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-bundle-contents"] && !Shopify.designMode) return;
  try {
    
  /* Tab activation. Uses data-bundle-* attribute names (distinct from
     the single-pack ves-pack-contents section's data-pack-*) so its click
     handler doesn't fight us for clicks on our tabs. */
  document.querySelectorAll('[data-bundle-explorer]').forEach(function (explorer) {
    if (explorer.dataset.vesBundleContentsInit === '1') return;
    explorer.dataset.vesBundleContentsInit = '1';

    var tabs = explorer.querySelectorAll('[data-bundle-tab]');
    var panels = explorer.querySelectorAll('[data-bundle-panel]');

    function activate(panelId) {
      tabs.forEach(function (t) {
        var match = t.getAttribute('aria-controls') === panelId;
        t.classList.toggle('is-active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var match = p.id === panelId;
        p.classList.toggle('is-active', match);
        if (match) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('aria-controls'));
      });
    });
  });

  /* Sample-clip tiles: lazy-attach src on first hover, play while
     hovered, pause on leave. Delegated so tab switches need no rebinding. */
  (function () {
    if (window.__vesBundleClipsInit) return;
    window.__vesBundleClipsInit = true;
    var TILE = '.ves-bundle-contents__clip';

    document.addEventListener('mouseover', function (event) {
      var tile = event.target.closest ? event.target.closest(TILE) : null;
      if (!tile || tile.contains(event.relatedTarget)) return;
      var video = tile.querySelector('video');
      if (!video) return;
      if (!video.getAttribute('src')) {
        var src = video.getAttribute('data-src');
        if (src) video.setAttribute('src', src);
      }
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    });

    document.addEventListener('mouseout', function (event) {
      var tile = event.target.closest ? event.target.closest(TILE) : null;
      if (!tile || tile.contains(event.relatedTarget)) return;
      var video = tile.querySelector('video');
      if (video) video.pause();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-bundle-fan"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.ves-bundle-fan');
    if (!sections.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;

    function setupFan(section) {
      if (section.dataset.fanReady === 'true') return;
      section.dataset.fanReady = 'true';

      var deck = section.querySelector('[data-fan-deck]');
      if (!deck) return;
      var covers = Array.prototype.slice.call(deck.querySelectorAll('[data-fan-cover]'));
      if (!covers.length) return;

      var n = covers.length;
      var mid = (n - 1) / 2;

      // Compute and store each card's resting fan transform.
      covers.forEach(function (el, i) {
        var off = i - mid;
        var rotY = off * -14;            // fan rotation
        var x = off * 142;               // horizontal spread
        var z = -Math.abs(off) * 46;     // edges pushed back in depth
        var yArc = Math.abs(off) * 16;   // edges sit lower (arc)
        var sc = 1 - Math.abs(off) * 0.05;
        el.style.zIndex = String(Math.round(50 - Math.abs(off) * 10));
        el.dataset.base =
          'translate(-50%,-50%) translateX(' + x + 'px) translateY(' + (yArc - 116) + 'px) ' +
          'translateZ(' + z + 'px) rotateY(' + rotY + 'deg) scale(' + sc + ')';
        el.style.transitionDelay = (i * 60) + 'ms';
      });

      function reveal() {
        section.classList.add('is-in');
        covers.forEach(function (el) {
          el.style.transform = el.dataset.base;
        });
        if (reduce || designMode) return;
        // Start the gentle float after the reveal settles.
        covers.forEach(function (el, i) {
          window.setTimeout(function () {
            var dur = 6 + Math.abs(i - mid) * 0.6;
            var delay = i * 0.4;
            el.style.animation = 'ves-bundle-fan-floaty ' + dur + 's ease-in-out ' + delay + 's infinite';
          }, 1100);
        });
      }

      // In the theme editor or reduced motion: snap to the final fan instantly.
      if (reduce || designMode) {
        covers.forEach(function (el) {
          el.style.transition = 'none';
        });
        reveal();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          requestAnimationFrame(function () {
            requestAnimationFrame(reveal);
          });
          io.disconnect();
        });
      }, { threshold: 0.3 });

      io.observe(section);
    }

    sections.forEach(setupFan);

    // Theme editor: re-run when this section is reloaded.
    if (designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        var node = event.target.querySelector('.ves-bundle-fan');
        if (node) setupFan(node);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-bundle-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-ves-bsh]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Touch devices: show the poster + a tap-to-play button instead of
    // auto-playing the heavy preview videos (saves mobile data and decode).
    var tapToPlay = window.matchMedia('(hover: none)').matches;

    roots.forEach(function (root) {
      var tabs = [].slice.call(root.querySelectorAll('[data-ves-bsh-tab]'));
      var panels = [].slice.call(root.querySelectorAll('[data-ves-bsh-panel]'));
      if (!tabs.length) return;
      if (tapToPlay) panels.forEach(ensurePlayBtn);

      // Cohesive entrance reveal: add .is-in when the section scrolls into view.
      if ('IntersectionObserver' in window) {
        var rio = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { root.classList.add('is-in'); obs.disconnect(); }
          });
        }, { rootMargin: '0px 0px -10% 0px' });
        rio.observe(root);
      } else {
        root.classList.add('is-in');
      }

      function ensurePlayBtn(panel) {
        if (!tapToPlay || panel._vesPlay) return panel._vesPlay || null;
        var v = panel.querySelector('video');
        if (!v) return null;
        var screen = panel.querySelector('.ves-bsh__screen') || panel;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ves-bsh__play';
        btn.setAttribute('aria-label', 'Play preview');
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
        btn.addEventListener('click', function () { playPanelVideo(panel, true); });
        screen.appendChild(btn);
        panel._vesPlay = btn;
        return btn;
      }

      function playPanelVideo(panel, userInitiated) {
        if (reduce) return;
        var v = panel.querySelector('video');
        if (!v) return;
        if (tapToPlay && !userInitiated) {
          var b = ensurePlayBtn(panel);
          if (b) b.style.display = '';
          return;
        }
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play();
        if (p && p.catch) { p.catch(function () {}); }
        if (panel._vesPlay) panel._vesPlay.style.display = 'none';
      }

      function stopPanelVideo(panel) {
        var v = panel.querySelector('video');
        if (!v) return;
        v.pause();
        try { v.currentTime = 0; } catch (e) {}
        if (panel._vesPlay) panel._vesPlay.style.display = '';
      }

      function activate(i) {
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, j) {
          var on = j === i;
          p.classList.toggle('is-active', on);
          if (on) {
            p.removeAttribute('hidden');
            playPanelVideo(p);
          } else {
            stopPanelVideo(p);
            p.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i); });
        t.addEventListener('keydown', function (e) {
          var idx = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') idx = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') idx = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') idx = 0;
          else if (e.key === 'End') idx = tabs.length - 1;
          if (idx !== null) { e.preventDefault(); activate(idx); tabs[idx].focus(); }
        });
      });

      var first = panels[0];
      if (first && !first.hasAttribute('hidden')) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) { playPanelVideo(first); obs.disconnect(); }
            });
          }, { rootMargin: '200px' });
          io.observe(root);
        } else {
          playPanelVideo(first);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ves-collection-hero').forEach(function (hero) {
      if (hero.dataset.vesInit === '1') return;
      hero.dataset.vesInit = '1';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { hero.classList.add('ves-revealed'); return; }
      // The banner sits at the top of the page; reveal it with a short beat so
      // the cascade plays as a clear entrance after the page paints.
      setTimeout(function () { hero.classList.add('ves-revealed'); }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-community"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* PART A: YouTube comment scatter + levitation reveal. Guarded so it runs
       independently of the ribbon block below. */
    var ytRoots = document.querySelectorAll('[data-ves-yt]');
    if (ytRoots.length) {
      var ytReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      ytRoots.forEach(function (root) {
        if (ytReduce || !('IntersectionObserver' in window)) {
          root.classList.add('is-in');
          return;
        }

        var stage = root.querySelector('[data-ves-yt-stage]') || root;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-in');
              io.disconnect();
            }
          });
        }, { threshold: 0.25 });

        io.observe(stage);
      });
    }

    /* PART B: Asset ribbon marquee + scroll boost + reveal. Guarded so it runs
       independently of the YouTube block above. */
    var ribbonRoots = document.querySelectorAll('[data-ves-ribbon]');
    if (ribbonRoots.length) {
      ribbonRoots.forEach(function (root) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var rowEls = [].slice.call(root.querySelectorAll('[data-ves-ribbon-row]'));
        if (!rowEls.length) return;

        var rows = rowEls.map(function (el) {
          var dir = parseInt(el.getAttribute('data-dir'), 10) || 1;
          var base = parseFloat(el.getAttribute('data-base')) || 0.4;
          return { el: el, x: 0, dir: dir, base: base, hw: 0 };
        });

        // Duplicate each row's cards once so a full set scrolls off seamlessly.
        rows.forEach(function (r) {
          var originals = [].slice.call(r.el.children);
          originals.forEach(function (node) {
            r.el.appendChild(node.cloneNode(true));
          });
        });

        function measure() {
          rows.forEach(function (r) {
            r.hw = r.el.scrollWidth / 2;
            r.x = r.dir < 0 ? -r.hw : 0;
            r.el.style.transform = 'translateX(' + r.x + 'px)';
          });
        }
        measure();
        window.addEventListener('resize', measure);

        if (reduce) return;

        var boost = 0;
        var lastScroll = window.scrollY;
        window.addEventListener('scroll', function () {
          var d = window.scrollY - lastScroll;
          lastScroll = window.scrollY;
          boost += d * 0.5;
          boost = Math.max(-60, Math.min(60, boost));
        }, { passive: true });

        function tick() {
          boost *= 0.9;
          rows.forEach(function (r) {
            r.x -= r.dir * (r.base + Math.abs(boost) * 0.04) + boost * 0.06 * r.dir;
            if (r.x <= -r.hw) r.x += r.hw;
            if (r.x > 0) r.x -= r.hw;
            r.el.style.transform = 'translateX(' + r.x + 'px)';
          });
          requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });

      ribbonRoots.forEach(function (root) {
        if (!('IntersectionObserver' in window)) {
          root.classList.add('is-in');
          return;
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-in');
              io.disconnect();
            }
          });
        }, { threshold: 0.2 });
        io.observe(root);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-fusion-comp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SVGNS = 'http://www.w3.org/2000/svg';

    function init(section) {
      if (section.dataset.vesFusionReady === '1') return;
      section.dataset.vesFusionReady = '1';

      var graph = section.querySelector('.ves-fusion__graph');
      if (!graph) return;

      var gradStroke = graph.querySelector('linearGradient');
      var pulseGrad = graph.querySelector('radialGradient');
      var glowAccFilter = graph.querySelectorAll('filter')[1];
      var accStrokeId = gradStroke ? gradStroke.id : '';
      var pulseId = pulseGrad ? pulseGrad.id : '';
      var glowAccId = glowAccFilter ? glowAccFilter.id : '';

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var designMode = !!(window.Shopify && window.Shopify.designMode);
      var finePointer = window.matchMedia('(pointer: fine)').matches;
      var instant = reduce || designMode;

      // Node-type accents resolve from VES theme tokens so they track the
      // merchant's accent settings; the hex is only a fallback if the var is unset.
      var cs = window.getComputedStyle(section);
      function token(name, fallback) {
        var v = cs.getPropertyValue(name);
        return (v && v.trim()) || fallback;
      }
      var ACC1 = token('--ves-accent-1', '#6a6fec');
      var ACC2 = token('--ves-accent-2', '#a06aec');
      var GOLD = token('--ves-gold', '#f5a623');
      var TYPE = {
        generator: { c: ACC1, name: 'Generator' },
        text: { c: ACC2, name: 'Text' },
        merge: { c: ACC2, name: 'Merge' },
        transform: { c: ACC1, name: 'Transform' },
        media: { c: ACC2, name: 'Media' },
        color: { c: GOLD, name: 'Color' },
        effect: { c: ACC2, name: 'Effect' }
      };

      var W = 132;
      var H = 58;
      var NODES = [
        { id: 'bg', x: 20, y: 64, label: 'Background', type: 'generator' },
        { id: 'text', x: 20, y: 196, label: 'Text+', type: 'text' },
        { id: 'mediain', x: 20, y: 436, label: 'MediaIn', type: 'media' },
        { id: 'mergeG', x: 215, y: 130, label: 'Merge', type: 'merge' },
        { id: 'color', x: 215, y: 436, label: 'Color', type: 'color' },
        { id: 'transform', x: 410, y: 130, label: 'Transform', type: 'transform' },
        { id: 'merge', x: 605, y: 285, label: 'Merge', type: 'merge' },
        { id: 'glow', x: 800, y: 285, label: 'Glow', type: 'effect' },
        { id: 'out', x: 990, y: 285, label: 'MediaOut', type: 'media', accent: true }
      ];
      var EDGES = [
        { from: 'bg', to: 'mergeG', port: 0 },
        { from: 'text', to: 'mergeG', port: 1 },
        { from: 'mediain', to: 'color', port: 0 },
        { from: 'mergeG', to: 'transform', port: 0 },
        { from: 'color', to: 'merge', port: 1 },
        { from: 'transform', to: 'merge', port: 0 },
        { from: 'merge', to: 'glow', port: 0 },
        { from: 'glow', to: 'out', port: 0 }
      ];

      var byId = {};
      NODES.forEach(function (n) { n.w = W; n.h = H; byId[n.id] = n; });
      var inCount = {};
      var hasIn = {};
      var hasOut = {};
      EDGES.forEach(function (e) {
        inCount[e.to] = (inCount[e.to] || 0) + 1;
        hasIn[e.to] = true;
        hasOut[e.from] = true;
      });

      function outPort(n) { return [n.x + n.w, n.y + n.h / 2]; }
      function inPort(n, port) {
        if ((inCount[n.id] || 0) >= 2) {
          return [n.x, n.y + n.h * (port === 1 ? 0.66 : 0.34)];
        }
        return [n.x, n.y + n.h / 2];
      }
      function pathD(e) {
        var a = outPort(byId[e.from]);
        var b = inPort(byId[e.to], e.port);
        var dx = b[0] - a[0];
        var h = Math.max(46, Math.abs(dx) * 0.5);
        return 'M ' + a[0] + ' ' + a[1] + ' C ' + (a[0] + h) + ' ' + a[1] + ', ' + (b[0] - h) + ' ' + b[1] + ', ' + b[0] + ' ' + b[1];
      }
      function el(tag, attrs) {
        var e = document.createElementNS(SVGNS, tag);
        for (var k in attrs) {
          if (Object.prototype.hasOwnProperty.call(attrs, k)) e.setAttribute(k, attrs[k]);
        }
        return e;
      }

      var gWires = graph.querySelector('.ves-fusion__wires');
      var gPulses = graph.querySelector('.ves-fusion__pulses');
      var gNodes = graph.querySelector('.ves-fusion__nodes');
      var gHalo = graph.querySelector('.ves-fusion__halo');

      var adjWires = {};
      var adjNodes = {};
      NODES.forEach(function (n) { adjWires[n.id] = []; adjNodes[n.id] = []; });

      var wireEls = [];
      EDGES.forEach(function (e, i) {
        var d = pathD(e);
        var p = el('path', { 'class': 'ves-fusion__wire', d: d });
        p.style.transitionDelay = (i * 0.11) + 's';
        gWires.appendChild(p);
        wireEls.push(p);

        if (!instant && pulseId) {
          var dot = el('circle', { 'class': 'ves-fusion__pulse', r: 9, fill: 'url(#' + pulseId + ')' });
          var am = el('animateMotion', {
            dur: (1.7 + (i % 3) * 0.25) + 's',
            repeatCount: 'indefinite',
            begin: (0.2 + i * 0.18) + 's',
            rotate: 'auto',
            calcMode: 'linear',
            path: d
          });
          dot.appendChild(am);
          gPulses.appendChild(dot);
        }

        adjWires[e.from].push(p);
        adjWires[e.to].push(p);
        if (adjNodes[e.from].indexOf(e.to) === -1) adjNodes[e.from].push(e.to);
        if (adjNodes[e.to].indexOf(e.from) === -1) adjNodes[e.to].push(e.from);
      });

      var accN = null;
      NODES.forEach(function (n) { if (n.accent) accN = n; });
      if (accN) {
        var hc = el('circle', {
          'class': 'ves-fusion__acc-halo',
          cx: accN.x + accN.w / 2,
          cy: accN.y + accN.h / 2,
          r: 78
        });
        gHalo.appendChild(hc);
      }

      var nodeEls = {};
      NODES.forEach(function (n) {
        var cls = 'ves-fusion__node' + (n.accent ? ' is-acc' : '');
        var g = el('g', { 'class': cls, 'data-id': n.id });

        var box = el('rect', { 'class': 'ves-fusion__box', x: n.x, y: n.y, width: n.w, height: n.h, rx: 11, ry: 11 });
        if (n.accent && accStrokeId) box.setAttribute('stroke', 'url(#' + accStrokeId + ')');
        if (n.accent && glowAccId) box.setAttribute('filter', 'url(#' + glowAccId + ')');
        g.appendChild(box);

        g.appendChild(el('circle', { 'class': 'ves-fusion__tdot', cx: n.x + 18, cy: n.y + n.h / 2, r: 5, fill: TYPE[n.type].c }));

        var t = el('text', { 'class': 'ves-fusion__label', x: n.x + 34, y: n.y + n.h / 2 - 7 });
        t.textContent = n.label;
        g.appendChild(t);

        var s = el('text', { 'class': 'ves-fusion__sub', x: n.x + 34, y: n.y + n.h / 2 + 15 });
        s.textContent = TYPE[n.type].name.toUpperCase();
        g.appendChild(s);

        if (hasOut[n.id]) {
          g.appendChild(el('circle', { 'class': 'ves-fusion__port', cx: n.x + n.w, cy: n.y + n.h / 2, r: 4 }));
        }
        if (hasIn[n.id]) {
          if ((inCount[n.id] || 0) >= 2) {
            g.appendChild(el('circle', { 'class': 'ves-fusion__port', cx: n.x, cy: n.y + n.h * 0.34, r: 4 }));
            g.appendChild(el('circle', { 'class': 'ves-fusion__port', cx: n.x, cy: n.y + n.h * 0.66, r: 4 }));
          } else {
            g.appendChild(el('circle', { 'class': 'ves-fusion__port', cx: n.x, cy: n.y + n.h / 2, r: 4 }));
          }
        }

        gNodes.appendChild(g);
        nodeEls[n.id] = g;

        if (finePointer && !instant) {
          g.addEventListener('pointerenter', function () { trace(n.id, true); });
          g.addEventListener('pointerleave', function () { trace(n.id, false); });
        }
      });

      function trace(id, on) {
        if (on) {
          NODES.forEach(function (m) { nodeEls[m.id].classList.add('is-dim'); });
          nodeEls[id].classList.remove('is-dim');
          nodeEls[id].classList.add('is-active');
          adjNodes[id].forEach(function (nid) {
            nodeEls[nid].classList.remove('is-dim');
            nodeEls[nid].classList.add('is-neighbor');
          });
          adjWires[id].forEach(function (w) { w.classList.add('is-hot'); });
        } else {
          NODES.forEach(function (m) {
            nodeEls[m.id].classList.remove('is-dim', 'is-active', 'is-neighbor');
          });
          wireEls.forEach(function (w) { w.classList.remove('is-hot'); });
        }
      }

      var legend = section.querySelector('.ves-fusion__legend');
      if (legend) {
        ['media', 'text', 'merge', 'transform', 'color', 'effect'].forEach(function (k) {
          var d = document.createElement('div');
          d.className = 'ves-fusion__legend-item';
          var dot = document.createElement('i');
          dot.style.background = TYPE[k].c;
          d.appendChild(dot);
          d.appendChild(document.createTextNode(TYPE[k].name));
          legend.appendChild(d);
        });
      }

      function showAll() {
        NODES.forEach(function (n) { nodeEls[n.id].classList.add('is-show'); });
        wireEls.forEach(function (w) { w.classList.add('is-drawn'); });
      }

      function play() {
        section.classList.add('is-in');
        if (instant) {
          showAll();
          return;
        }
        var order = ['bg', 'text', 'mediain', 'mergeG', 'color', 'transform', 'merge', 'glow', 'out'];
        order.forEach(function (id, i) {
          setTimeout(function () { nodeEls[id].classList.add('is-show'); }, 360 + i * 85);
        });
        wireEls.forEach(function (w, i) {
          setTimeout(function () { w.classList.add('is-drawn'); }, 700 + i * 110);
        });
        setTimeout(function () { graph.classList.add('is-flowing'); }, 1700);
      }

      if (instant) {
        play();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          play();
          io.disconnect();
        });
      }, { threshold: 0.35 });
      io.observe(section);
    }

    function boot() {
      var sections = document.querySelectorAll('.ves-fusion');
      for (var i = 0; i < sections.length; i++) init(sections[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var node = e.target.querySelector ? e.target.querySelector('.ves-fusion') : null;
      if (node) init(node);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-fusion-vs-edit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SVGNS = 'http://www.w3.org/2000/svg';

    /* ---- LEFT: the Fusion node graph ---- */
    function init(section) {
      if (section.dataset.vesFveReady === '1') return;
      section.dataset.vesFveReady = '1';

      var graph = section.querySelector('.ves-fve__graph');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var designMode = !!(window.Shopify && window.Shopify.designMode);
      var finePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
      var instant = reduce || designMode || !graph;

      if (!graph) {
        section.classList.add('is-in');
        return;
      }

      var pulseGrad = graph.querySelector('radialGradient');
      var pulseId = pulseGrad ? pulseGrad.id : '';

      var cs = window.getComputedStyle(section);
      function token(name, fallback) {
        var v = cs.getPropertyValue(name);
        return (v && v.trim()) || fallback;
      }
      var GREEN = '#6fcf7d';
      var ORANGE = token('--ves-gold', '#f5a623');
      var PURPLE = token('--ves-accent-2', '#a06aec');
      var TYPE = {
        text: GREEN,
        generator: GREEN,
        transform: ORANGE,
        merge: ORANGE,
        effect: PURPLE,
        media: PURPLE
      };

      var W = 96;
      var H = 36;
      // Nodes are inset with an even margin on all sides of the 640x400 viewBox so
      // they never touch the stage edges; the graph reads balanced, not cropped.
      var NODES = [
        { id: 'bg', x: 60, y: 44, label: 'Background', type: 'generator' },
        { id: 'text', x: 60, y: 182, label: 'Text+', type: 'text' },
        { id: 'mediain', x: 60, y: 320, label: 'MediaIn', type: 'media' },
        { id: 'merge1', x: 200, y: 108, label: 'Merge', type: 'merge' },
        { id: 'xf', x: 200, y: 256, label: 'Transform', type: 'transform' },
        { id: 'merge2', x: 340, y: 182, label: 'Merge', type: 'merge' },
        { id: 'glow', x: 480, y: 290, label: 'Glow', type: 'effect' },
        { id: 'out', x: 480, y: 74, label: 'MediaOut', type: 'media' }
      ];
      var EDGES = [
        { from: 'bg', to: 'merge1', port: 0 },
        { from: 'text', to: 'merge1', port: 1 },
        { from: 'mediain', to: 'xf', port: 0 },
        { from: 'merge1', to: 'merge2', port: 0 },
        { from: 'xf', to: 'merge2', port: 1 },
        { from: 'merge2', to: 'glow', port: 0 },
        { from: 'glow', to: 'out', port: 0 }
      ];

      var byId = {};
      NODES.forEach(function (n) { n.w = W; n.h = H; byId[n.id] = n; });
      var inCount = {};
      var hasIn = {};
      var hasOut = {};
      EDGES.forEach(function (e) {
        inCount[e.to] = (inCount[e.to] || 0) + 1;
        hasIn[e.to] = true;
        hasOut[e.from] = true;
      });

      function outPort(n) { return [n.x + n.w, n.y + n.h / 2]; }
      function inPort(n, port) {
        if ((inCount[n.id] || 0) >= 2) {
          return [n.x, n.y + n.h * (port === 1 ? 0.68 : 0.32)];
        }
        return [n.x, n.y + n.h / 2];
      }
      function pathD(e) {
        var a = outPort(byId[e.from]);
        var b = inPort(byId[e.to], e.port);
        var dx = b[0] - a[0];
        var h = Math.max(34, Math.abs(dx) * 0.5);
        return 'M ' + a[0] + ' ' + a[1] + ' C ' + (a[0] + h) + ' ' + a[1] + ', ' + (b[0] - h) + ' ' + b[1] + ', ' + b[0] + ' ' + b[1];
      }
      function el(tag, attrs) {
        var e = document.createElementNS(SVGNS, tag);
        for (var k in attrs) {
          if (Object.prototype.hasOwnProperty.call(attrs, k)) e.setAttribute(k, attrs[k]);
        }
        return e;
      }

      var gWires = graph.querySelector('.ves-fve__wires');
      var gPulses = graph.querySelector('.ves-fve__pulses');
      var gNodes = graph.querySelector('.ves-fve__nodes');

      var adjWires = {};
      var adjNodes = {};
      NODES.forEach(function (n) { adjWires[n.id] = []; adjNodes[n.id] = []; });

      var wireEls = [];
      EDGES.forEach(function (e, i) {
        var d = pathD(e);
        var green = (e.from === 'text' || e.from === 'bg');
        var p = el('path', { 'class': 'ves-fve__wire' + (green ? ' ves-fve__wire--green' : ''), d: d });
        p.style.transitionDelay = (i * 0.1) + 's';
        gWires.appendChild(p);
        wireEls.push(p);

        if (!instant && pulseId) {
          var dot = el('circle', { 'class': 'ves-fve__pulse', r: 6, fill: 'url(#' + pulseId + ')' });
          var am = el('animateMotion', {
            dur: (1.6 + (i % 3) * 0.25) + 's',
            repeatCount: 'indefinite',
            begin: (0.2 + i * 0.18) + 's',
            rotate: 'auto',
            calcMode: 'linear',
            path: d
          });
          dot.appendChild(am);
          gPulses.appendChild(dot);
        }

        adjWires[e.from].push(p);
        adjWires[e.to].push(p);
        if (adjNodes[e.from].indexOf(e.to) === -1) adjNodes[e.from].push(e.to);
        if (adjNodes[e.to].indexOf(e.from) === -1) adjNodes[e.to].push(e.from);
      });

      var nodeEls = {};
      NODES.forEach(function (n) {
        var g = el('g', { 'class': 'ves-fve__node', 'data-id': n.id });
        var color = TYPE[n.type] || PURPLE;

        g.appendChild(el('rect', { 'class': 'ves-fve__box', x: n.x, y: n.y, width: n.w, height: n.h, rx: 6, ry: 6 }));
        g.appendChild(el('rect', {
          'class': 'ves-fve__under',
          x: n.x + 4,
          y: n.y + n.h - 2.5,
          width: n.w - 8,
          height: 2,
          rx: 1,
          fill: color
        }));
        var t = el('text', { 'class': 'ves-fve__nlabel', x: n.x + n.w / 2, y: n.y + n.h / 2 - 1 });
        t.textContent = n.label;
        g.appendChild(t);
        g.appendChild(el('rect', { 'class': 'ves-fve__handle', x: n.x + n.w / 2 - 3, y: n.y + n.h - 3, width: 6, height: 6, rx: 1 }));
        if (hasIn[n.id]) {
          var iy = n.y + n.h / 2;
          g.appendChild(el('path', { 'class': 'ves-fve__tri-in', d: 'M ' + (n.x - 6) + ' ' + (iy - 4) + ' L ' + n.x + ' ' + iy + ' L ' + (n.x - 6) + ' ' + (iy + 4) + ' Z' }));
        }
        if (hasOut[n.id]) {
          var oy = n.y + n.h / 2;
          var ox = n.x + n.w;
          g.appendChild(el('path', { 'class': 'ves-fve__tri-out', d: 'M ' + ox + ' ' + (oy - 4) + ' L ' + (ox + 6) + ' ' + oy + ' L ' + ox + ' ' + (oy + 4) + ' Z' }));
        }

        gNodes.appendChild(g);
        nodeEls[n.id] = g;

        if (finePointer && !instant) {
          g.addEventListener('pointerenter', function () { trace(n.id, true); });
          g.addEventListener('pointerleave', function () { trace(n.id, false); });
        }
      });

      function trace(id, on) {
        if (on) {
          NODES.forEach(function (m) { nodeEls[m.id].classList.add('is-dim'); });
          nodeEls[id].classList.remove('is-dim');
          nodeEls[id].classList.add('is-active');
          adjNodes[id].forEach(function (nid) {
            nodeEls[nid].classList.remove('is-dim');
            nodeEls[nid].classList.add('is-neighbor');
          });
          adjWires[id].forEach(function (w) { w.classList.add('is-hot'); });
        } else {
          NODES.forEach(function (m) {
            nodeEls[m.id].classList.remove('is-dim', 'is-active', 'is-neighbor');
          });
          wireEls.forEach(function (w) { w.classList.remove('is-hot'); });
        }
      }

      function showAll() {
        NODES.forEach(function (n) { nodeEls[n.id].classList.add('is-show'); });
        wireEls.forEach(function (w) { w.classList.add('is-drawn'); });
      }

      function play() {
        section.classList.add('is-in');
        if (instant) {
          showAll();
          return;
        }
        var order = ['bg', 'text', 'mediain', 'merge1', 'xf', 'merge2', 'glow', 'out'];
        order.forEach(function (id, i) {
          setTimeout(function () { nodeEls[id].classList.add('is-show'); }, 340 + i * 80);
        });
        wireEls.forEach(function (w, i) {
          setTimeout(function () { w.classList.add('is-drawn'); }, 660 + i * 100);
        });
        setTimeout(function () { graph.classList.add('is-flowing'); }, 1600);
      }

      if (instant) {
        play();
        return;
      }

      if (!('IntersectionObserver' in window)) {
        play();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          play();
          io.disconnect();
        });
      }, { threshold: 0.25 });
      io.observe(section);
    }

    /* ---- RIGHT: the Edit page. Bar width animates and drives the chart bar width. ---- */
    function initEdit(section) {
      if (section.dataset.vesFveEditReady === '1') return;
      var edit = section.querySelector('[data-ves-fve-edit]');
      if (!edit) return;
      section.dataset.vesFveEditReady = '1';

      var bars = edit.querySelector('[data-fve-bars]');
      var bwNum = edit.querySelector('[data-fve-bw-num]');
      var bwFill = edit.querySelector('[data-fve-bw-fill]');

      // Map a Bar width value (0.20..1.00) to the number field, the ticked slider
      // fill, and the width of the chart bars (--bw drives scaleX on each bar).
      // The bars get thin but never disappear, and the chart is NOT scaled.
      function apply(v) {
        var norm = (v - 0.2) / 0.8;
        if (norm < 0) norm = 0;
        if (norm > 1) norm = 1;
        if (bwNum) { bwNum.textContent = v.toFixed(2); }
        if (bwFill) { bwFill.style.width = (12 + norm * 50).toFixed(1) + '%'; }
        if (bars) { bars.style.setProperty('--bw', v.toFixed(3)); }
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var designMode = !!(window.Shopify && window.Shopify.designMode);
      var raf = window.requestAnimationFrame;

      // Static, sensible pose first so it never shows an unstyled frame.
      apply(0.7);

      if (reduce || designMode || !bars || !raf) {
        return;
      }

      var LO = 0.2;
      var HI = 1.0;
      var PERIOD = 5200;
      var rafId = null;
      var startTs = null;

      function frame(ts) {
        if (startTs === null) startTs = ts;
        var t = ((ts - startTs) % PERIOD) / PERIOD;
        var e = 0.5 - 0.5 * Math.cos(t * 2 * Math.PI);
        apply(LO + e * (HI - LO));
        rafId = raf(frame);
      }

      function start() { if (rafId === null) { startTs = null; rafId = raf(frame); } }
      function stop() {
        if (rafId !== null) {
          if (window.cancelAnimationFrame) window.cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) start(); else stop();
          });
        }, { threshold: 0.2 });
        io.observe(edit);
      } else {
        start();
      }
    }

    function boot() {
      var sections = document.querySelectorAll('[data-ves-fve]');
      for (var i = 0; i < sections.length; i++) {
        init(sections[i]);
        initEdit(sections[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var node = e.target.querySelector ? e.target.querySelector('[data-ves-fve]') : null;
      if (node) { init(node); initEdit(node); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROOT_SELECTOR = '[data-ves-gallery-band]';
    var REVEAL_CLASS = 'is-revealed';

    function revealAll(bands) {
      for (var i = 0; i < bands.length; i++) {
        bands[i].classList.add(REVEAL_CLASS);
      }
    }

    function init(scope) {
      var bands = (scope || document).querySelectorAll(ROOT_SELECTOR);
      if (!bands.length) {
        return;
      }

      var reduceMotion =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var designMode = window.Shopify && window.Shopify.designMode;

      // In the theme editor or with reduced motion, render the final state
      // immediately so no content is hidden behind an animation.
      if (reduceMotion || designMode || !('IntersectionObserver' in window)) {
        revealAll(bands);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (entry.isIntersecting) {
              entry.target.classList.add(REVEAL_CLASS);
              observer.unobserve(entry.target);
            }
          }
        },
        { threshold: 0.18 }
      );

      for (var j = 0; j < bands.length; j++) {
        observer.observe(bands[j]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    // Re-run when a merchant adds or edits this section in the theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ves-nav]').forEach(function (nav) {
      if (nav.dataset.vesInit === '1') return;
      nav.dataset.vesInit = '1';

      /* ---- Sticky shrink + auto-hide on scroll ---- */
      var closeMegaMenu = null; // assigned by the mega-menu block below
      // Seed from the real scroll position so a deep-link / mid-page refresh
      // never hides the bar on load; only an actual scroll gesture can.
      var lastScroll = window.scrollY < 0 ? 0 : window.scrollY;
      var dirRef = lastScroll;
      var lastDir = 0;
      var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var reduceMotion = rmq ? rmq.matches : false;
      if (rmq && rmq.addEventListener) {
        rmq.addEventListener('change', function (e) {
          reduceMotion = e.matches;
          if (e.matches) nav.classList.remove('is-hidden');
        });
      }
      function onScroll() {
        var y = window.scrollY;
        if (y < 0) y = 0;
        if (y === lastScroll) return;
        nav.classList.toggle('is-scrolled', y > 40);

        // Direction with hysteresis: checkpoint the reversal point, then require
        // intent before toggling (hide after 50px down, reveal after 8px up).
        var dir = y > lastScroll ? 1 : -1;
        if (dir !== lastDir) { dirRef = lastScroll; lastDir = dir; }

        var drawerOpen = document.body.classList.contains('ves-scroll-locked');
        if (reduceMotion || drawerOpen || y <= 90) {
          nav.classList.remove('is-hidden');
        } else if (dir === 1 && y - dirRef > 50) {
          nav.classList.add('is-hidden');
          if (closeMegaMenu) closeMegaMenu(); // do not strand an open mega menu off-screen
        } else if (dir === -1 && dirRef - y > 8) {
          nav.classList.remove('is-hidden');
        }
        lastScroll = y;
      }
      // Initial shrink state only; the bar is never auto-hidden on load.
      nav.classList.toggle('is-scrolled', lastScroll > 40);
      window.addEventListener('scroll', onScroll, { passive: true });

      /* ---- Mega menu (hover on desktop, click everywhere else) ---- */
      var megaTrigger = nav.querySelector('[data-ves-mega-trigger]');
      var mega = document.getElementById(megaTrigger?.getAttribute('aria-controls') || '');
      if (mega && megaTrigger) {
        var hoverTimer = null;
        var OPEN_DELAY = 80;
        var CLOSE_DELAY = 220;
        function isHoverDevice() {
          return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        }
        function openMega() {
          mega.classList.add('is-open');
          megaTrigger.setAttribute('aria-expanded', 'true');
          mega.setAttribute('aria-hidden', 'false');
        }
        function closeMega() {
          mega.classList.remove('is-open');
          megaTrigger.setAttribute('aria-expanded', 'false');
          mega.setAttribute('aria-hidden', 'true');
        }
        closeMegaMenu = closeMega; // let the auto-hide handler dismiss it
        function scheduleOpen() { clearTimeout(hoverTimer); hoverTimer = setTimeout(openMega, OPEN_DELAY); }
        function scheduleClose() { clearTimeout(hoverTimer); hoverTimer = setTimeout(closeMega, CLOSE_DELAY); }
        function cancelTimer() { clearTimeout(hoverTimer); }

        megaTrigger.addEventListener('mouseenter', function () { if (isHoverDevice()) scheduleOpen(); });
        megaTrigger.addEventListener('mouseleave', function () { if (isHoverDevice()) scheduleClose(); });
        mega.addEventListener('mouseenter', function () { if (isHoverDevice()) cancelTimer(); });
        mega.addEventListener('mouseleave', function () { if (isHoverDevice()) scheduleClose(); });

        megaTrigger.addEventListener('click', function (e) {
          // Hover devices: hover already handles the drawer, so a click
          // follows the link to the bundle comparison page (modified clicks
          // keep their native new-tab behavior automatically, it's an <a>).
          if (isHoverDevice()) return;
          // Touch: first tap opens the drawer instead of navigating; a second
          // tap on the trigger (drawer open) follows the link.
          if (!mega.classList.contains('is-open')) {
            e.preventDefault();
            openMega();
          }
        });

        document.addEventListener('click', function (e) {
          if (!mega.classList.contains('is-open')) return;
          if (mega.contains(e.target) || megaTrigger.contains(e.target)) return;
          closeMega();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && mega.classList.contains('is-open')) closeMega();
        });
      }

      /* ---- Search uses Horizon's #search-modal (declarative on:click in markup). ---- */

      /* ---- Mobile drawer ---- */
      var hamburger = nav.querySelector('[data-ves-hamburger]');
      var drawerId = hamburger?.getAttribute('aria-controls');
      var drawer = drawerId ? document.getElementById(drawerId) : null;
      var scrim = document.querySelector('.ves-mobile-scrim');
      function openDrawer() {
        if (!drawer) return;
        drawer.setAttribute('data-open', '1');
        drawer.setAttribute('aria-hidden', 'false');
        if (scrim) scrim.setAttribute('data-open', '1');
        hamburger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('ves-scroll-locked');
      }
      function closeDrawer() {
        if (!drawer) return;
        drawer.removeAttribute('data-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (scrim) scrim.removeAttribute('data-open');
        hamburger?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('ves-scroll-locked');
      }
      hamburger?.addEventListener('click', openDrawer);
      document.querySelectorAll('[data-ves-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      drawer?.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { closeDrawer(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer?.getAttribute('data-open') === '1') closeDrawer();
      });

      /* ---- Mobile accordion ---- */
      document.querySelectorAll('[data-ves-accordion]').forEach(function (acc) {
        var toggle = acc.querySelector('[data-ves-accordion-toggle]');
        if (!toggle) return;
        toggle.addEventListener('click', function () {
          var open = acc.getAttribute('data-open') === '1';
          if (open) {
            acc.removeAttribute('data-open');
            toggle.setAttribute('aria-expanded', 'false');
          } else {
            acc.setAttribute('data-open', '1');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });

      /* ---- Drawer inline search ----
         Live results render in the panel under the bar (predictive-search
         JSON API); the menu boxes hide while a query is present (the
         .is-searching CSS) and come back when the input empties. Enter
         submits the form to the full search page as usual. */
      var msInput = drawer ? drawer.querySelector('[data-ves-msearch-input]') : null;
      var msClear = drawer ? drawer.querySelector('[data-ves-msearch-clear]') : null;
      var msResults = drawer ? drawer.querySelector('[data-ves-msearch-results]') : null;
      if (drawer && msInput && msResults) {
        var msTimer = null;
        var msSeq = 0;

        function msEscape(t) {
          var d = document.createElement('div');
          d.textContent = t;
          return d.innerHTML;
        }

        function msPrice(v) {
          var n = parseFloat(v);
          if (isNaN(n)) return '';
          return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
        }

        function msExit() {
          drawer.classList.remove('is-searching');
          msResults.hidden = true;
          msResults.innerHTML = '';
          if (msClear) msClear.hidden = true;
        }

        function msRender(q, products) {
          var html = '';
          products.slice(0, 8).forEach(function (p) {
            var img = p.featured_image && p.featured_image.url
              ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96'
              : '';
            // Compare-at price + savings, mirroring the cart line treatment.
            var priceN = parseFloat(p.price);
            var cmpN = parseFloat(p.compare_at_price_max || 0);
            var pricing;
            if (!isNaN(cmpN) && cmpN > priceN) {
              var pct = Math.round(((cmpN - priceN) / cmpN) * 100);
              pricing = '<span class="ves-mobile-menu__result-pricing">'
                + '<span class="ves-mobile-menu__result-priceline">'
                + '<span class="ves-mobile-menu__result-price">' + msPrice(p.price) + '</span>'
                + '<s class="ves-mobile-menu__result-compare">' + msPrice(cmpN) + '</s>'
                + '</span>'
                + '<span class="ves-mobile-menu__result-save">Save ' + pct + '%</span>'
                + '</span>';
            } else {
              pricing = '<span class="ves-mobile-menu__result-price">' + msPrice(p.price) + '</span>';
            }
            html += '<a class="ves-mobile-menu__result" href="' + p.url + '">'
              + (img ? '<img class="ves-mobile-menu__result-thumb" src="' + img + '" alt="" width="32" height="45" loading="lazy">' : '')
              + '<span class="ves-mobile-menu__result-name">' + msEscape(p.title) + '</span>'
              + pricing
              + '</a>';
          });
          if (products.length === 0) {
            html = '<div class="ves-mobile-menu__results-empty">Nothing matches "' + msEscape(q) + '". Try another word.</div>';
          } else {
            html += '<a class="ves-mobile-menu__results-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results'
              + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg></a>';
          }
          msResults.innerHTML = html;
          msResults.hidden = false;
          drawer.classList.add('is-searching');
        }

        msInput.addEventListener('input', function () {
          var q = msInput.value.trim();
          if (msClear) msClear.hidden = q === '';
          window.clearTimeout(msTimer);
          if (q === '') {
            msExit();
            return;
          }
          msTimer = window.setTimeout(function () {
            var seq = ++msSeq;
            fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide', {
              headers: { Accept: 'application/json' }
            })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (d) {
                if (seq !== msSeq) return; // a newer query superseded this one
                if (msInput.value.trim() === '') return; // cleared while in flight
                var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
                msRender(q, prods);
              })
              .catch(function () {});
          }, 220);
        });

        if (msClear) {
          msClear.addEventListener('click', function () {
            msInput.value = '';
            msExit();
            try { msInput.focus(); } catch (e) {}
          });
        }

        // Closing the drawer resets the search so it reopens on the menu.
        document.addEventListener('click', function (e) {
          if (e.target && e.target.closest && e.target.closest('[data-ves-drawer-close]')) {
            msInput.value = '';
            msExit();
          }
        });
      }
    });

    /* Cart count live update.
       Horizon fires `cart:update` (CartAddEvent.eventName === ThemeEvents.cartUpdate),
       with detail = { resource: cart, sourceId, data: {...} }. An earlier
       version listened for `cart:updated` and read `detail.cart`, neither
       of which exist in Horizon, so the badge never refreshed and adds
       looked like they did nothing. */
    document.addEventListener('cart:update', function (e) {
      var resource = e && e.detail && e.detail.resource;
      var count = resource && typeof resource.item_count === 'number'
        ? resource.item_count
        : null;
      // No resource on the event (e.g., our own remove-handler dispatch
      // doesn't always include it), fall back to /cart.js.
      if (count == null) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          if (typeof c.item_count === 'number') updateBadges(c.item_count);
        }).catch(function () {});
        return;
      }
      updateBadges(count);
    });

    function updateBadges(count) {
      document.querySelectorAll('[data-ves-cart-count]').forEach(function (badge) {
        badge.textContent = count;
        badge.classList.toggle('is-empty', count === 0);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ves-countdown]').forEach(function (el) {
    if (el.dataset.vesInit === '1') return;
    el.dataset.vesInit = '1';

    var launchIso = el.dataset.launch;
    var format = el.dataset.format || 'long';
    if (!launchIso) return;

    var launch = new Date(launchIso).getTime();
    if (isNaN(launch)) return;

    var timer = null;

    function tick() {
      var now = Date.now();
      var delta = Math.max(0, Math.floor((launch - now) / 1000));

      if (delta === 0) {
        el.textContent = el.dataset.expiredLabel || 'Now live';
        if (timer) clearInterval(timer);
        return;
      }

      var d = Math.floor(delta / 86400);
      var h = Math.floor((delta % 86400) / 3600);
      var m = Math.floor((delta % 3600) / 60);
      var s = delta % 60;

      if (format === 'long') {
        if (d > 1) {
          el.textContent = d + 'd ' + h + 'h ' + m + 'm ' + s + 's';
        } else {
          var totalHours = Math.floor(delta / 3600);
          el.textContent = totalHours + 'h ' + m + 'm ' + s + 's';
        }
      } else {
        el.textContent = h + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      }
    }

    tick();
    timer = setInterval(tick, 1000);
  });

  document.querySelectorAll('[data-ves-hero-switch]').forEach(function (sw) {
    if (sw.dataset.vesInit === '1') return;
    sw.dataset.vesInit = '1';
    var hero = sw.closest('section') || document;
    var price = hero.querySelector('[data-ves-hero-price]');
    var compare = hero.querySelector('[data-ves-hero-compare]');
    var save = hero.querySelector('[data-ves-hero-save]');
    var cta = hero.querySelector('[data-ves-upgrade-bundle]');
    var descCurrent = hero.querySelector('[data-ves-hero-desc="current"]');
    var descCompanion = hero.querySelector('[data-ves-hero-desc="companion"]');
    sw.querySelectorAll('.ves-hero__switch-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-active')) return;
        sw.querySelectorAll('.ves-hero__switch-opt').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (descCurrent && descCompanion) {
          descCurrent.hidden = btn.dataset.descTarget !== 'current';
          descCompanion.hidden = btn.dataset.descTarget !== 'companion';
        }
        if (price) price.textContent = btn.dataset.price;
        var hasCompare = !!btn.dataset.compare;
        if (compare) {
          compare.textContent = btn.dataset.compare || '';
          compare.hidden = !hasCompare;
        }
        if (save) {
          save.textContent = 'Save ' + btn.dataset.save + '%';
          save.hidden = !hasCompare || btn.dataset.save === '0';
        }
        if (cta) {
          cta.setAttribute('data-bundle-variant-id', btn.dataset.variantId);
          cta.setAttribute('data-bundle-product-id', btn.dataset.productId);
          cta.setAttribute('data-bundle-title', btn.dataset.title);
          cta.setAttribute('data-bundle-url', btn.dataset.url);
          cta.setAttribute('data-bundle-img', btn.dataset.img);
          cta.setAttribute('data-bundle-price', btn.dataset.price);
          cta.setAttribute('data-bundle-compare', btn.dataset.compare || '');
        }
      });
    });
    // ?edition=lifetime (the Bundles menu card) opens the page with the companion edition selected.
    if (new URLSearchParams(window.location.search).get('edition') === 'lifetime') {
      var companionOpt = sw.querySelector('.ves-hero__switch-opt[data-desc-target="companion"]');
      if (companionOpt) companionOpt.click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-home-hero-reel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-ves-hero-reel]');
    if (!sections.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(pointer:fine)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;

    sections.forEach(function (root) {
      var inner = root.querySelector('[data-ves-field-inner]');
      if (!inner) return;

      // Cursor-reactive 3D parallax. Only on fine pointers, never under
      // reduced motion, and skipped in the theme editor where the camera
      // should stay still. One passive listener + a single rAF loop.
      if (reduce || designMode || !fine) return;

      var tx = 0;
      var ty = 0;
      var cx = 0;
      var cy = 0;
      var running = false;

      function onMove(e) {
        tx = e.clientX / window.innerWidth - 0.5;
        ty = e.clientY / window.innerHeight - 0.5;
        if (!running) {
          running = true;
          requestAnimationFrame(loop);
        }
      }

      function loop() {
        cx += (tx - cx) * 0.06;
        cy += (ty - cy) * 0.06;
        inner.style.setProperty('--ves-hr-rx', (cx * 14).toFixed(2) + 'deg');
        inner.style.setProperty('--ves-hr-ry', (-cy * 10).toFixed(2) + 'deg');
        // Keep looping while there is still meaningful motion to settle.
        if (Math.abs(tx - cx) > 0.0005 || Math.abs(ty - cy) > 0.0005) {
          requestAnimationFrame(loop);
        } else {
          running = false;
        }
      }

      window.addEventListener('mousemove', onMove, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var bars = document.querySelectorAll('[data-ves-hiw-bars]');
    if (!bars.length) { return; }

    bars.forEach(function (el) {
      // Reduced motion or no observer: leave bars in their final pose.
      if (reduce || typeof IntersectionObserver === 'undefined') { return; }

      // Arm: collapse the bars, then let them rise when scrolled into view.
      el.classList.add('ves-hiw__bars--armed');

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.35 });

      io.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-map-stack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    if (reduced || mobile || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('[data-mstack-root]').forEach(function (root) {
      if (root.dataset.vesMstackBound) return;
      root.dataset.vesMstackBound = '1';

      var stage = root.querySelector('[data-mstack-stage]');
      var stack = root.querySelector('[data-mstack-3d]');
      var finalEl = root.querySelector('[data-mstack-final]');
      var hlEl = root.querySelector('[data-mstack-hl]');
      var coEl = root.querySelector('[data-mstack-callout]');
      var layers = Array.prototype.slice.call(stack.querySelectorAll('.ves-mstack__layer'));
      var chips = Array.prototype.slice.call(root.querySelectorAll('.ves-mstack__chip'));
      var N = layers.length;
      var tiltX = 0, tiltY = 0, ticking = false, active = false;

      // No pin, so the build is keyed to WHERE the stage sits in the
      // viewport, not to a fixed scroll distance. A fixed distance paced
      // the whole build while the block was still rising through the bottom
      // of the screen (on a tall display it finished before the block
      // reached readable height) and paced differently per screen size.
      // These are fractions of viewport height measured to the SECTION's top
      // edge: nothing happens until the section has climbed past the midline,
      // so the visitor is looking at it before it starts, and it settles as
      // the section reaches the top of the screen.
      var START_AT = 0.5;  // section top crosses the middle of the screen
      var END_AT = 0.05;   // section top reaches the top of the screen

      function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
      function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
      function smooth(a, b, p) { return clamp((p - a) / (b - a)); }

      function update() {
        ticking = false;
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = clamp((START_AT * vh - r.top) / ((START_AT - END_AT) * vh));
        var cross = smooth(0.86, 0.965, p);
        var flat = easeOut(smooth(0.45, 1, p));
        var rotX = 55 - 51 * flat;
        var rotZ = -8 * (1 - flat);
        var rotY = Math.sin(p * Math.PI) * 3;
        stack.style.transform = 'rotateX(' + (rotX + tiltX) + 'deg) rotateY(' + (rotY + tiltY * 0.25) + 'deg) rotateZ(' + (rotZ + tiltY * 0.15) + 'deg)';

        for (var i = 0; i < N; i++) {
          var arrive = (i / N) * 0.78;
          var local = easeOut(smooth(arrive, arrive + 0.2, p));
          var restZ = (i - N / 2) * 40;
          var startZ = restZ + 170;
          var z = startZ + (restZ - startZ) * local;
          layers[i].style.transform = 'translateZ(' + z + 'px)';
          layers[i].style.opacity = (local * (1 - cross)).toFixed(3);
          if (chips[i]) {
            chips[i].classList.toggle('is-arriving', local > 0.02 && local < 0.98 && cross < 0.5);
            chips[i].classList.toggle('is-landed', local >= 0.98 || cross >= 0.5);
          }
        }
        finalEl.style.opacity = cross.toFixed(3);
        hlEl.style.opacity = (smooth(0.9, 0.98, p) * 0.5).toFixed(3);
        coEl.style.opacity = smooth(0.93, 1, p).toFixed(3);
      }

      function onScroll() {
        if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
      }

      new IntersectionObserver(function (entries) {
        var hit = entries[0].isIntersecting;
        if (hit && !active) { active = true; window.addEventListener('scroll', onScroll, { passive: true }); update(); }
        else if (!hit && active) { active = false; window.removeEventListener('scroll', onScroll); }
      }, { rootMargin: '200px' }).observe(root);

      if (window.matchMedia('(pointer: fine)').matches) {
        stage.addEventListener('pointermove', function (ev) {
          tiltX = ((ev.clientY / window.innerHeight) - 0.5) * -6;
          tiltY = ((ev.clientX / window.innerWidth) - 0.5) * 10;
          onScroll();
        });
      }
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-map-style-lab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ves-mlab').forEach(function (root) {
      if (root.dataset.vesMlabBound) return;
      root.dataset.vesMlabBound = '1';

      var lands = Array.prototype.slice.call(root.querySelectorAll('[data-mlab-land]'));
      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-mlab-tile]'));
      var counter = root.querySelector('[data-mlab-counter]');
      var counterName = root.querySelector('[data-mlab-counter-name]');
      var counterOf = root.querySelector('.ves-mlab__counter-of');
      var styleValue = root.querySelector('[data-mlab-style-value]');
      var targetValue = root.querySelector('[data-mlab-target-value]');
      var modeValue = root.querySelector('[data-mlab-mode-value]');
      var modeHint = root.querySelector('[data-mlab-mode-hint]');
      var ovFill = root.querySelector('[data-mlab-ov="fill"]');
      var ovOutline = root.querySelector('[data-mlab-ov="outline"]');
      var ovFlag = root.querySelector('[data-mlab-ov="flag"]');
      var segTarget = root.querySelector('[data-mlab-seg-target]');
      var segMode = root.querySelector('[data-mlab-seg-mode]');
      var totalStyles = (counter && counter.dataset.mlabTotal) || '44';

      // Highlight masks per target, read from data attributes on segTarget
      // (the URLs come from Liquid's asset_url server-side; this file stays
      // pure static JS).
      var masks = { country: {}, region: {}, subregion: {} };
      if (segTarget) {
        masks.country.fill = segTarget.dataset.fillCountry;
        masks.country.outline = segTarget.dataset.outlineCountry;
        masks.region.fill = segTarget.dataset.fillRegion;
        masks.region.outline = segTarget.dataset.outlineRegion;
        masks.subregion.fill = segTarget.dataset.fillSubregion;
        masks.subregion.outline = segTarget.dataset.outlineSubregion;
      }
      var hintEnabled = (segTarget && segTarget.dataset.hintEnabled) || '';
      var hintDisabled = (segTarget && segTarget.dataset.hintDisabled) || '';

      var state = { target: 'region', mode: 'fill' };

      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          var idx = parseInt(tile.dataset.mlabIndex, 10) - 1;
          tiles.forEach(function (t) { t.classList.toggle('is-on', t === tile); t.setAttribute('aria-selected', t === tile ? 'true' : 'false'); });
          lands.forEach(function (l, i) { l.classList.toggle('is-on', i === idx); l.hidden = i !== idx; });
          var name = tile.dataset.mlabName;
          if (counterName) counterName.textContent = name;
          if (counterOf) counterOf.textContent = '· style ' + (idx + 1) + ' of ' + tiles.length + ' shown · ' + totalStyles + ' in the pack';
          if (styleValue) styleValue.textContent = name;
        });
      });

      function applyOverlay() {
        [ovFill, ovOutline, ovFlag].forEach(function (o) { o.classList.remove('is-on'); });
        var m = masks[state.target];
        if (state.mode === 'fill') {
          ovFill.style.webkitMaskImage = ovFill.style.maskImage = 'url(' + m.fill + ')';
          ovFill.classList.add('is-on');
          if (modeValue) modeValue.textContent = 'Fill';
        } else if (state.mode === 'outline') {
          ovOutline.style.webkitMaskImage = ovOutline.style.maskImage = 'url(' + m.outline + ')';
          ovOutline.classList.add('is-on');
          if (modeValue) modeValue.textContent = 'Outline';
        } else if (state.mode === 'flag') {
          ovFlag.style.webkitMaskImage = ovFlag.style.maskImage = 'url(' + m.fill + ')';
          ovFlag.classList.add('is-on');
          if (modeValue) modeValue.textContent = 'Image';
        }
      }

      if (segTarget) {
        segTarget.addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (!b) return;
          state.target = b.dataset.mlabTarget;
          Array.prototype.forEach.call(segTarget.children, function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (targetValue) targetValue.textContent = b.textContent;

          var flagBtn = segMode.querySelector('[data-mlab-mode="flag"]');
          if (state.target !== 'country') {
            flagBtn.disabled = true;
            if (state.mode === 'flag') {
              state.mode = 'fill';
              Array.prototype.forEach.call(segMode.children, function (x) { x.classList.toggle('is-on', x.dataset.mlabMode === 'fill'); x.setAttribute('aria-pressed', x.dataset.mlabMode === 'fill' ? 'true' : 'false'); });
            }
            if (modeHint) modeHint.textContent = hintDisabled;
          } else {
            flagBtn.disabled = false;
            if (modeHint) modeHint.textContent = hintEnabled;
          }
          applyOverlay();
        });
      }

      if (segMode) {
        segMode.addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (!b || b.disabled) return;
          state.mode = b.dataset.mlabMode;
          Array.prototype.forEach.call(segMode.children, function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          applyOverlay();
        });
      }

      applyOverlay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-map-workflow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var videos = document.querySelectorAll('[data-mwf-video]');
    if (!videos.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.4] });
    videos.forEach(function (v) { io.observe(v); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-pack-contents"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pack-explorer]').forEach(function (explorer) {
    if (explorer.dataset.vesInit === '1') return;
    explorer.dataset.vesInit = '1';

    var tabs = explorer.querySelectorAll('[data-pack-tab]');
    var panels = explorer.querySelectorAll('[data-pack-panel]');
    var isMobile = function () { return window.matchMedia('(max-width: 768px)').matches; };

    // Per-panel video helpers. Inactive videos stay preload="none"; the active
    // one bumps to "auto" and plays. This keeps page weight low even with 13+
    // category clips on the page.
    function syncVideo(panel, shouldPlay) {
      // Shopify's video_tag emits a plain <video>, no data-pack-media attribute,
      // so look up any video inside the panel's media wrapper.
      var v = panel.querySelector('[data-pack-media-wrap] video') || panel.querySelector('video');
      if (!v) return;
      if (shouldPlay) {
        if (v.preload !== 'auto') v.preload = 'auto';
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        v.pause();
      }
    }

    function activate(panelId) {
      tabs.forEach(function (t) {
        var match = t.getAttribute('aria-controls') === panelId;
        t.classList.toggle('is-active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var match = p.id === panelId;
        if (isMobile()) {
          p.classList.toggle('is-expanded', match);
          p.removeAttribute('hidden');
        } else {
          if (match) {
            p.removeAttribute('hidden');
            p.classList.add('is-expanded');
          } else {
            p.setAttribute('hidden', '');
            p.classList.remove('is-expanded');
          }
        }
        syncVideo(p, match);
      });
    }

    function toggleMobile(panelId) {
      panels.forEach(function (p) {
        var match = p.id === panelId;
        if (match) {
          var nowExpanded = !p.classList.contains('is-expanded');
          p.classList.toggle('is-expanded');
          syncVideo(p, nowExpanded);
        } else {
          p.classList.remove('is-expanded');
          syncVideo(p, false);
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('aria-controls'));
      });
    });

    panels.forEach(function (panel) {
      var header = panel.querySelector('[data-pack-header]');
      if (!header) return;
      header.addEventListener('click', function () {
        if (isMobile()) {
          toggleMobile(panel.id);
        } else {
          activate(panel.id);
        }
      });
    });

    // Kick the initially-active panel's video on load.
    var initiallyActive = explorer.querySelector('.ves-pack__panel.is-active');
    if (initiallyActive) syncVideo(initiallyActive, true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-pack-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript ? document.currentScript.closest('.ves-pack-grid') : null;
    section = section || document.querySelector('.ves-pack-grid');
    if (!section || section.dataset.vesInit === '1') return;
    section.dataset.vesInit = '1';

    /* Reveal the toolbar (filters, search, sort) when the section enters view. */
    (function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) { section.classList.add('ves-revealed'); return; }
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            obs.disconnect();
            setTimeout(function () { section.classList.add('ves-revealed'); }, 120);
          }
        });
      }, { rootMargin: '0px 0px -5% 0px' });
      io.observe(section);
    })();

    var url = new URL(window.location.href);

    /* Mobile filter toggle: opens/closes the sidebar panel on small screens
       (the sidebar is a desktop rail, hidden below 900px). */
    var filterToggle = section.querySelector('[data-ves-filter-toggle]');
    var sidebar = section.querySelector('.ves-pack-grid__sidebar');
    if (filterToggle && sidebar) {
      filterToggle.addEventListener('click', function () {
        var open = sidebar.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* Price slider: two stacked range inputs. Labels and the gradient fill
       update live; releasing a thumb navigates to the filtered URL (same
       full-reload model as every other filter link). */
    section.querySelectorAll('[data-ves-price]').forEach(function (root) {
      var minI = root.querySelector('[data-price-min]');
      var maxI = root.querySelector('[data-price-max]');
      var fill = root.querySelector('[data-price-fill]');
      var labMin = root.querySelector('[data-price-label-min]');
      var labMax = root.querySelector('[data-price-label-max]');
      var rangeMax = parseFloat(root.dataset.rangeMax) || 100;

      function paint() {
        var lo = Math.min(parseFloat(minI.value), parseFloat(maxI.value));
        var hi = Math.max(parseFloat(minI.value), parseFloat(maxI.value));
        if (labMin) labMin.textContent = '$' + lo;
        if (labMax) labMax.textContent = '$' + hi + (root.dataset.capped && hi >= rangeMax ? '+' : '');
        if (fill) {
          fill.style.left = (lo / rangeMax * 100) + '%';
          fill.style.width = ((hi - lo) / rangeMax * 100) + '%';
        }
      }

      function clamp(e) {
        if (parseFloat(minI.value) > parseFloat(maxI.value)) {
          if (e.target === minI) maxI.value = minI.value;
          else minI.value = maxI.value;
        }
        paint();
      }

      function apply() {
        var lo = Math.min(parseFloat(minI.value), parseFloat(maxI.value));
        var hi = Math.max(parseFloat(minI.value), parseFloat(maxI.value));
        var url = new URL(window.location.href);
        url.searchParams.delete('page');
        if (lo > 0) url.searchParams.set(root.dataset.minParam, lo);
        else url.searchParams.delete(root.dataset.minParam);
        if (hi < rangeMax) url.searchParams.set(root.dataset.maxParam, hi);
        else url.searchParams.delete(root.dataset.maxParam);
        window.location.href = url.toString();
      }

      [minI, maxI].forEach(function (inp) {
        inp.addEventListener('input', clamp);
        inp.addEventListener('change', apply);
      });
      paint();
    });

    /* Filtering is now native: the sidebar renders from collection.filters
       and each value is an <a> linking to its Shopify filter URL (full
       reload, server-side filtered). No custom filter JS needed. */

    /* --- Sort tabs ---
       currentSort comes from data-current-sort, which the server computed and
       used to paint the active pill. Reading the SAME value here means the JS
       re-applies the identical active state (no flash of the wrong pill).
       Falls back to the URL param / Latest default if the attribute is absent.
       The genuine product order on the default view is set by the collection's
       admin default sort ("Date, new to old" to match the Latest tab). */
    var sortTabsEl = section.querySelector('.ves-pack-grid__sort-tabs');
    var currentSort = (sortTabsEl && sortTabsEl.dataset.currentSort)
      || url.searchParams.get('sort_by') || 'created-descending';
    section.querySelectorAll('.ves-pack-grid__sort-tab').forEach(function (tab) {
      tab.classList.remove('is-active', 'descending', 'ascending');
      var sort = tab.dataset.sort;
      if (sort === 'trending' && (currentSort === 'manual' || currentSort === 'best-selling')) {
        tab.classList.add('is-active');
      }
      if (sort === 'latest' && currentSort === 'created-descending') {
        tab.classList.add('is-active');
      }
      if (sort === 'price' && (currentSort === 'price-ascending' || currentSort === 'price-descending')) {
        tab.classList.add('is-active');
        if (currentSort === 'price-descending') tab.classList.add('descending');
        else tab.classList.add('ascending');
      }

      // Make the price sort direction explicit (the arrow flips visually; this
      // adds a matching label + tooltip for clarity and screen readers).
      if (sort === 'price') {
        var priceDir = currentSort === 'price-descending'
          ? 'high to low'
          : (currentSort === 'price-ascending' ? 'low to high' : '');
        if (priceDir) {
          tab.setAttribute('aria-label', 'Sorted by price ' + priceDir + '. Activate to reverse.');
          tab.title = 'Price: ' + priceDir;
        } else {
          tab.setAttribute('aria-label', 'Sort by price, low to high');
          tab.title = 'Sort by price';
        }
      }

      tab.addEventListener('click', function () {
        var next = new URL(window.location.href);
        var s = '';
        if (sort === 'trending') s = 'best-selling';
        else if (sort === 'latest') s = 'created-descending';
        else if (sort === 'price') {
          var curr = next.searchParams.get('sort_by');
          s = curr === 'price-ascending' ? 'price-descending' : 'price-ascending';
        }
        next.searchParams.set('sort_by', s);
        next.searchParams.delete('page');
        window.location.href = next.toString();
      });
    });

    /* --- Search: client-side filter by name + tagline ---
       Honors ?q= from the URL so the search modal can deep-link into a
       pre-filtered grid.

       The grid only renders the current PAGE (paginate by 24), so a search
       limited to the DOM would miss matches on later pages. On the first
       keystroke we fetch the remaining pages once, append their cards
       (hidden) tagged data-ves-extra, and filter across the COMPLETE set.
       Pagination hides while a query is active (every match is on screen)
       and returns when the box empties; the extra cards re-hide so the
       original page-1 view is restored. The hover-preview module and the
       row equalizer both pick up the appended cards automatically (their
       MutationObservers watch for added cards / data-hidden flips). */
    var searchInput = section.querySelector('.ves-pack-grid__search input');
    var gridEl = section.querySelector('.ves-pack-grid__grid');

    /* Staggered entrance: reveal the cards (one by one via per-card delay) when
       the grid scrolls into view. Composited transform/opacity only. */
    if (gridEl) {
      var reduceMo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMo || !('IntersectionObserver' in window)) {
        gridEl.classList.add('is-revealed');
      } else {
        var gridReveal = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              obs.disconnect();
              // A short beat so an above-the-fold grid plays its cascade as a
              // clear entrance after the page paints, not buried in page load.
              setTimeout(function () { gridEl.classList.add('is-revealed'); }, 180);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px' });
        gridReveal.observe(gridEl);
      }
    }
    var paginationEl = section.querySelector('.ves-pack-grid__pagination');
    var searchEmptyEl = section.querySelector('[data-search-empty]');
    var extrasState = 'none'; // none -> loading -> loaded

    function liveCards() {
      return section.querySelectorAll('.ves-pack-card');
    }

    function applySearch(q) {
      var needle = (q || '').trim().toLowerCase();
      var anyMatch = false;
      liveCards().forEach(function (card) {
        var isExtra = card.getAttribute('data-ves-extra') === '1';
        if (needle === '') {
          // Restore the original page view: extras hide, page cards show.
          if (isExtra) card.setAttribute('data-hidden', '1');
          else card.removeAttribute('data-hidden');
          return;
        }
        var name = (card.querySelector('.ves-pack-card__name') || {}).textContent || '';
        var tagline = (card.querySelector('.ves-pack-card__tagline') || {}).textContent || '';
        var match = name.toLowerCase().indexOf(needle) !== -1 || tagline.toLowerCase().indexOf(needle) !== -1;
        if (match) {
          card.removeAttribute('data-hidden');
          anyMatch = true;
        } else {
          card.setAttribute('data-hidden', '1');
        }
      });
      if (paginationEl) paginationEl.style.display = needle === '' ? '' : 'none';
      if (searchEmptyEl) {
        searchEmptyEl.hidden = !(needle !== '' && !anyMatch);
        if (!searchEmptyEl.hidden) {
          var label = searchEmptyEl.querySelector('[data-search-empty-term]');
          if (label) label.textContent = q.trim();
        }
      }
    }

    // Fetch pages 2..N of the current collection view once, so the client
    // filter sees the whole catalog (not just the rendered page).
    function loadAllPagesOnce() {
      if (extrasState !== 'none' || !gridEl) return;
      var maxPage = 1;
      section.querySelectorAll('.ves-pack-grid__pagination .ves-pack-grid__page-link').forEach(function (el) {
        var n = parseInt(el.textContent, 10);
        if (!isNaN(n) && n > maxPage) maxPage = n;
      });
      if (maxPage <= 1) {
        extrasState = 'loaded';
        return;
      }
      extrasState = 'loading';
      var pending = 0;
      for (var p = 2; p <= maxPage; p++) {
        (function (pageNum) {
          pending++;
          var u = new URL(window.location.href);
          u.searchParams.set('page', pageNum);
          fetch(u.toString())
            .then(function (r) { return r.text(); })
            .then(function (txt) {
              var doc = new DOMParser().parseFromString(txt, 'text/html');
              doc.querySelectorAll('.ves-pack-grid__grid .ves-pack-card').forEach(function (card) {
                card.setAttribute('data-ves-extra', '1');
                card.setAttribute('data-hidden', '1');
                gridEl.appendChild(document.importNode(card, true));
              });
            })
            .catch(function () {})
            .finally(function () {
              pending--;
              if (pending === 0) {
                extrasState = 'loaded';
                // Re-run with the current query so late-arriving cards join in.
                if (searchInput) applySearch(searchInput.value);
              }
            });
        })(p);
      }
    }

    if (searchInput) {
      var urlQuery = url.searchParams.get('q');
      // On the /search template the grid is ALREADY server-filtered by the
      // query (and the server matches more fields than the client filter,
      // e.g. descriptions), so re-running the client filter here could hide
      // legitimate results. Prefill the box but skip the client pass there.
      var isSearchPage = window.location.pathname.indexOf('/search') === 0;
      if (urlQuery) {
        searchInput.value = urlQuery;
        if (!isSearchPage) {
          loadAllPagesOnce();
          applySearch(urlQuery);
        }
      }
      searchInput.addEventListener('input', function (e) {
        if (!isSearchPage && e.target.value.trim() !== '') loadAllPagesOnce();
        applySearch(e.target.value);
      });
    }

    /* --- Hover media ---
       Handled globally by assets/ves-pack-card-hover.js, which initializes
       every .ves-pack-card on any surface (collection, recommendations, quiz,
       homepage) with viewport-preload + is-hover-ready reveal + play/pause.
       Kept out of this section so there's a single source of truth. */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-pick-your-lane"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-ves-lane]');
    roots.forEach(function (root) {
      var tabs = [].slice.call(root.querySelectorAll('[data-ves-lane-tab]'));
      var panels = [].slice.call(root.querySelectorAll('[data-ves-lane-panel]'));
      if (!tabs.length) return;

      function activate(i) {
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, j) {
          var on = j === i;
          p.classList.toggle('is-active', on);
          if (on) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          activate(i);
        });
        t.addEventListener('keydown', function (e) {
          var idx = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') idx = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') idx = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') idx = 0;
          else if (e.key === 'End') idx = tabs.length - 1;
          if (idx !== null) {
            e.preventDefault();
            activate(idx);
            tabs[idx].focus();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-pricing-bundles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function bind(card) {
      var video = card.querySelector('[data-ves-bundle-hover-video]');
      if (!video || card.dataset.vesHoverBound === '1') return;
      card.dataset.vesHoverBound = '1';

      function start() {
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
      }
      function stop() {
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
      }
      card.addEventListener('mouseenter', start);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focusin', start);
      card.addEventListener('focusout', stop);
    }

    function boot() {
      document.querySelectorAll('.ves-pricing-bundles__card').forEach(bind);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-proof-bar"] && !Shopify.designMode) return;
  try {
    
  /* Trust-badge fallback: links pointing at #reviews normally smooth-scroll
     to the on-page reviews section (handler in ves-reviews). But that
     section hides on products with fewer than 3 five-star reviews, so on
     those pages the anchor is absent (or rendered hidden). When the section
     is not visible, send the click to the on-site all-reviews page in a new
     tab instead of scrolling to nothing. */
  (function () {
    if (window.__vesReviewsBadgeFallback) return;
    window.__vesReviewsBadgeFallback = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href="#reviews"]');
      if (!link) return;
      var anchor = document.getElementById('reviews');
      var section = anchor && anchor.closest('.ves-reviews');
      // Visible section: let the ves-reviews scroll handler take it.
      if (section && section.offsetParent !== null) return;
      e.preventDefault();
      window.open('/pages/review', '_blank', 'noopener');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ves-quiz').forEach(function (quiz) {
    if (quiz.dataset.vesInit === '1') return;
    quiz.dataset.vesInit = '1';

    var state = { q1: null, q2: null, q3: null, q4: null };

    /* ---- Quiz analytics ----
       One capture point, three destinations:
       1. Anonymous beacons to the merchant's collector endpoint (theme
          setting; blank = off). One event per answer click, one per
          completion, one per result CTA. No PII: sid is a random
          per-run id so one run's rows can be grouped.
       2. localStorage, so capture forms elsewhere on the site (free
          starter pack) can attach the profile to known leads.
       3. Cart attributes on the results CTA, so orders carry the
          buyer's quiz profile into Shopify admin.
       Analytics must never break the quiz: every call is try-wrapped
       and fire-and-forget. */
    var LOG_URL = quiz.dataset.quizLogUrl || '';
    var LOG_TOKEN = quiz.dataset.quizLogToken || '';
    var sid = Math.random().toString(36).slice(2, 10);
    function logEvent(payload) {
      if (!LOG_URL) return;
      try {
        payload.sid = sid;
        payload.token = LOG_TOKEN;
        payload.ts = new Date().toISOString();
        payload.vw = window.innerWidth;
        var body = JSON.stringify(payload);
        if (navigator.sendBeacon) navigator.sendBeacon(LOG_URL, body);
        else fetch(LOG_URL, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' });
      } catch (e) { /* never break the quiz for analytics */ }
    }
    function persistProfile(matchName) {
      try {
        localStorage.setItem('ves_quiz_profile', JSON.stringify({
          q1: state.q1, q2: state.q2, q3: state.q3, q4: state.q4,
          match: matchName || '', ts: Date.now()
        }));
      } catch (e) {}
    }
    function quizMlFields() {
      return [
        ['quiz_profile', state.q1], ['quiz_work', state.q2],
        ['quiz_experience', state.q3], ['quiz_pain', state.q4]
      ];
    }

    function show(step) {
      quiz.querySelectorAll('.ves-quiz__step').forEach(function (s) {
        var match = s.dataset.step === step;
        s.classList.toggle('is-active', match);
        // Toggle the `hidden` attribute too so non-active steps are
        // truly hidden from initial parse (prevents FOUC: all 6 steps
        // flashing for a frame on first paint before CSS applies).
        if (match) s.removeAttribute('hidden');
        else s.setAttribute('hidden', '');
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    /* Option clicks auto-advance. Read the next-step destination from
       the parent `.ves-quiz__options` data attribute. Short delay so
       the user sees their selection highlighted before the page
       transitions. */
    var ADVANCE_DELAY_MS = 280;
    quiz.querySelectorAll('.ves-quiz__options').forEach(function (group) {
      var qkey = group.dataset.question;
      var dest = group.dataset.nextStep;
      group.querySelectorAll('.ves-quiz__option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          group.querySelectorAll('.ves-quiz__option').forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          state[qkey] = opt.dataset.value;
          logEvent({ t: 'answer', q: qkey, v: opt.dataset.value });
          if (!dest) return;
          setTimeout(function () {
            if (dest === 'analyzing') startAnalysis();
            else show(dest);
          }, ADVANCE_DELAY_MS);
        });
      });
    });

    /* Start / back / restart */
    quiz.querySelectorAll('[data-quiz-start]').forEach(function (b) {
      b.addEventListener('click', function () { show('1'); });
    });
    quiz.querySelectorAll('[data-quiz-back]').forEach(function (b) {
      b.addEventListener('click', function () { show(b.dataset.quizBack); });
    });
    quiz.querySelectorAll('[data-quiz-restart]').forEach(function (b) {
      b.addEventListener('click', function () {
        Object.keys(state).forEach(function (k) { state[k] = null; });
        sid = Math.random().toString(36).slice(2, 10);
        quiz.querySelectorAll('.ves-quiz__option.is-selected').forEach(function (o) { o.classList.remove('is-selected'); });
        show('1');
      });
    });

    /* Analysis sequence: reveal steps one by one, then route to results */
    function startAnalysis() {
      show('analyzing');
      var steps = quiz.querySelectorAll('.ves-quiz__astep');
      steps.forEach(function (s, i) {
        setTimeout(function () { s.classList.add('is-done'); }, 350 + i * 420);
      });
      setTimeout(function () {
        renderResult();
        show('results');
      }, 350 + steps.length * 420 + 400);
    }

    /* ============ RECOMMENDATION ENGINE ============
       Ported from mockups/quiz.html. Reads the bundle data island
       Liquid emits at the bottom of the section (real Shopify product
       data + ves.* metafields), maps quiz state to a primary +
       optional secondary bundle, builds a tailored "Why we picked
       this" sentence, then renders the result UI. */

    // Bundle data from the JSON data island
    var BUNDLES = {};
    try {
      var dataEl = document.querySelector('[data-ves-quiz-bundles]');
      if (dataEl) BUNDLES = JSON.parse(dataEl.textContent);
    } catch (e) { console.error('[ves-quiz] bundle data parse failed', e); }

    // Q2 value → bundle key
    var CATEGORY_TO_BUNDLE = {
      narrative: 'narrative',
      explainer: 'explainer',
      online: 'online',
      cinematic: 'cinematic',
      infographic: 'infographic'
    };

    // Q4 pain-point → flavor sentence appended to the primary reason
    var PAIN_LINES = {
      generic: 'Every pack is hand-built for editors. No template-store look.',
      scratch: 'Drop them straight into your Resolve timeline. No Fusion node-tree to figure out.',
      consistency: 'Every pack shares a visual system, so your work stays coherent across projects.',
      standout: "These aren't on every other YouTube channel. Built for editors who don't want to blend in."
    };

    function computeRecommendation() {
      var q1 = state.q1, q2 = state.q2, q4 = state.q4;
      var matched = (q2 && q2 !== 'diverse') ? BUNDLES[CATEGORY_TO_BUNDLE[q2]] : null;
      var pain = (q4 && PAIN_LINES[q4]) ? PAIN_LINES[q4] : '';

      // 1. Studios → always Pro Bundle, secondary = matched (or Transition)
      if (q1 === 'studio') {
        return {
          primary: BUNDLES.pro,
          secondary: matched || BUNDLES.transition,
          primaryReason: ("You said you're a studio or company. The Pro Bundle gives your team every pack we've made and everything we ship until December 2027. " + pain).trim()
        };
      }

      // 2. Diverse work (non-studio) → Transition Bundle, secondary = Cinematic
      if (q2 === 'diverse') {
        return {
          primary: BUNDLES.transition,
          secondary: BUNDLES.cinematic,
          primaryReason: ("You said your work doesn't fit one category. Transitions work in any kind of edit. " + (BUNDLES.transition.priceFormatted || '') + ' gets you ' + (BUNDLES.transition.packCount || '') + ' packs that go with everything. ' + pain).trim()
        };
      }

      // 3. Specialty bundle by Q2
      if (matched) {
        var audience = (matched.eyebrow || '').toLowerCase();
        var savePart = '';
        if (matched.compareAt && matched.compareAt > matched.price) {
          var saving = matched.compareAt - matched.price;
          savePart = '$' + Math.round(saving).toLocaleString() + ' less than buying the packs separately.';
        }
        // If the bundle's audience eyebrow metafield isn't set, swap the
        // opening sentence so we don't render the awkward "You said you
        // edit . The Bundle..." string. The fallback lead uses lowercase
        // "the" since it's a continuation after the comma.
        var sentence = audience
          ? ('You said you edit ' + audience + '. The ' + matched.name + ' is ')
          : ('Based on your answers, the ' + matched.name + ' is ');
        return {
          primary: matched,
          secondary: BUNDLES.transition,
          primaryReason: (sentence + (matched.packCount || '') + ' packs and ' + (matched.assetCount || '') + ' assets built for exactly that. ' + savePart + ' ' + pain).replace(/\s+/g, ' ').trim()
        };
      }

      // Fallback (shouldn't reach in normal flow)
      return {
        primary: BUNDLES.transition,
        secondary: BUNDLES.cinematic,
        primaryReason: ('The Transition Bundle works in any kind of edit. Good universal starting point. ' + pain).trim()
      };
    }

    /* ============ RESULT RENDERING ============ */

    function setText(selector, text) {
      var el = quiz.querySelector(selector);
      if (el) el.textContent = text || '';
    }
    function setHidden(selector, hide) {
      var el = quiz.querySelector(selector);
      if (el) {
        if (hide) el.setAttribute('hidden', '');
        else el.removeAttribute('hidden');
      }
    }

    function renderResult() {
      var rec = computeRecommendation();
      var p = rec.primary || {};
      if (!p.name) {
        console.warn('[ves-quiz] no matched bundle, skipping render');
        return;
      }

      // Title: "The {Bundle Name}". Pro Bundle uses a short form
      // ("The Pro Bundle") to match the conversational eyebrow above.
      var title;
      if (p.key === 'pro') title = 'The Pro Bundle';
      else title = 'The ' + p.name.replace(/^The\s+/, '');
      var titleEl = quiz.querySelector('[data-result-title]');
      if (titleEl) titleEl.textContent = title;
      // Subtitle is two lines per design. Use innerHTML so the <br> from
      // the static markup renders the same way after a JS re-render.
      var subEl = quiz.querySelector('[data-result-sub]');
      if (subEl) subEl.innerHTML = 'Based on what you told us, this is what fits cleanest.<br>Get it now, or try the free sample first.';

      // Cover image: trailer thumbnail (from metafield) or placeholder.
      var coverImg = quiz.querySelector('[data-result-cover-img]');
      var coverPh = quiz.querySelector('[data-result-cover-placeholder]');
      if (p.cover) {
        if (coverImg) { coverImg.src = p.cover; coverImg.alt = p.name; coverImg.removeAttribute('hidden'); }
        if (coverPh) coverPh.setAttribute('hidden', '');
      } else {
        if (coverImg) coverImg.setAttribute('hidden', '');
        if (coverPh) { coverPh.removeAttribute('hidden'); coverPh.textContent = p.key === 'pro' ? 'Pro Bundle cover' : 'Bundle cover'; }
      }

      logEvent({ t: 'complete', q1: state.q1, q2: state.q2, q3: state.q3, q4: state.q4, match: p.name || '' });
      persistProfile(p.name || '');

      setText('[data-result-eyebrow]', p.eyebrow || '');
      setText('[data-result-name]', p.name);
      setText('[data-result-tagline]', p.tagline || '');
      setText('[data-result-reason]', rec.primaryReason);

      // Stats strip: packs / assets / bonuses (Pro gets a "future packs"
      // cell). The bonuses cell only renders when there ARE bonuses, a
      // "0 bonuses" stat undersells rather than informs.
      var statsEl = quiz.querySelector('[data-result-stats]');
      if (statsEl) {
        var statsHtml =
          '<span class="ves-quiz__card-stat"><strong>' + (p.packCount || '0') + '</strong> packs</span>' +
          '<span class="ves-quiz__card-stat"><strong>' + (p.assetCount || '0') + '</strong> assets</span>';
        if (p.key === 'pro') {
          statsHtml += '<span class="ves-quiz__card-stat">New packs <strong>until Dec 2027</strong></span>';
        } else if (parseInt(p.bonusCount, 10) > 0) {
          statsHtml += '<span class="ves-quiz__card-stat"><strong>' + p.bonusCount + '</strong> bonuses</span>';
        }
        statsEl.innerHTML = statsHtml;
      }

      // Prices
      setText('[data-result-price]', p.priceFormatted || '');
      var compareEl = quiz.querySelector('[data-result-compare]');
      var saveEl = quiz.querySelector('[data-result-save]');
      if (p.compareAt && p.compareAt > p.price) {
        if (compareEl) { compareEl.textContent = p.compareFormatted; compareEl.removeAttribute('hidden'); }
        if (saveEl) { saveEl.textContent = 'Save $' + Math.round(p.compareAt - p.price).toLocaleString(); saveEl.removeAttribute('hidden'); }
      } else {
        if (compareEl) compareEl.setAttribute('hidden', '');
        if (saveEl) saveEl.setAttribute('hidden', '');
      }

      // CTAs: fast-add button data + secondary link. Populate the
      // data-ves-pack-add button's attributes from the matched bundle so the
      // shared fast handler (ves-cart.js) can add it + open the drawer.
      var primaryCta = quiz.querySelector('[data-result-cta-primary]');
      if (primaryCta) {
        primaryCta.textContent = 'Add to cart · ' + (p.priceFormatted || '');
        primaryCta.setAttribute('data-variant-id', p.variantId || '');
        primaryCta.setAttribute('data-product-id', p.variantId || '');
        primaryCta.setAttribute('data-product-title', p.name || '');
        primaryCta.setAttribute('data-product-url', p.url || '');
        primaryCta.setAttribute('data-product-img', p.cover || '');
        primaryCta.setAttribute('data-product-price', p.priceFormatted || '');
        primaryCta.setAttribute('data-product-compare', p.compareFormatted || '');
        if (!primaryCta.dataset.vesQuizWired) {
          primaryCta.dataset.vesQuizWired = '1';
          primaryCta.addEventListener('click', function () {
            logEvent({ t: 'cta', action: 'add_to_cart', match: primaryCta.getAttribute('data-product-title') || '' });
            try {
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: {
                  'Quiz profile': state.q1 || '',
                  'Quiz work type': state.q2 || '',
                  'Quiz experience': state.q3 || '',
                  'Quiz pain point': state.q4 || '',
                  'Quiz match': primaryCta.getAttribute('data-product-title') || ''
                } })
              });
            } catch (e) {}
          });
        }
      }
      var secondaryCta = quiz.querySelector('[data-result-cta-secondary]');
      if (secondaryCta) { secondaryCta.href = p.url || '#'; secondaryCta.textContent = p.key === 'pro' ? 'View the Pro Bundle' : 'View the bundle'; }

      renderInside(p);
      renderSample(p);
    }

    function renderInside(p) {
      var insideBlock = quiz.querySelector('[data-result-inside]');
      if (!insideBlock) return;

      // No included packs → hide the whole block (also true for the Pro
      // Bundle if its included_packs metafield hasn't been set yet).
      if (!p.insideHtml || !p.insideHtml.trim()) {
        insideBlock.style.display = 'none';
        return;
      }
      insideBlock.style.display = '';

      var isPro = p.key === 'pro';
      var inside = p.inside || [];

      setText('[data-result-inside-eyebrow]', "What's inside");
      setText('[data-result-inside-title]', isPro ? (inside.length + ' specialty bundles') : p.name);

      var individualTotal = inside.reduce(function (sum, i) { return sum + (i.price || 0); }, 0);
      var meta = (p.packCount || inside.length) + (isPro ? ' bundles' : ' packs') + ' · ' + (p.assetCount || '') + ' assets';
      if (individualTotal > 0) meta += ' · individually $' + Math.round(individualTotal).toLocaleString();
      setText('[data-result-inside-meta]', meta);

      // Liquid pre-rendered each included pack via the ves-pack-card
      // snippet (same one used on the collection page), JS just drops
      // it in. CSS styles come from assets/ves-base.css and apply
      // automatically. After injecting, re-bind the hover-media
      // listeners so the cards' poster→video crossfade fires the same
      // way as on the collection page.
      var grid = quiz.querySelector('[data-result-inside-grid]');
      if (grid) grid.innerHTML = p.insideHtml;
      // Hover-media on the injected pack cards is bound automatically by the
      // global assets/ves-pack-card-hover.js (its MutationObserver picks them
      // up when this innerHTML lands).

      var footerEl = quiz.querySelector('[data-result-inside-footer]');
      var totalCount = inside.length;
      var visibleCount = Math.min(totalCount, 6);
      var remainder = totalCount - visibleCount;
      if (footerEl) {
        // Pro Bundle gets a special extra note from the mockup,
        // independent of the remainder count.
        if (isPro) {
          footerEl.removeAttribute('hidden');
          footerEl.innerHTML = '+ standalone packs and every pack we ship until December 2027';
        } else if (remainder > 0 && p.url) {
          footerEl.removeAttribute('hidden');
          footerEl.innerHTML = '+ ' + remainder + ' more pack' + (remainder > 1 ? 's' : '') + ' not shown here. <a href="' + p.url + '">View the full ' + p.name + '</a>';
        } else {
          footerEl.setAttribute('hidden', '');
        }
      }
    }

    /**
     * Prefix the bundle name with "the " unless it already starts with
     * an article. "Narrative Bundle" → "the Narrative Bundle".
     * "The Pro Bundle" → "The Pro Bundle" (no double article).
     */
    function withArticle(name) {
      if (!name) return '';
      return /^the\s+/i.test(name) ? name : ('the ' + name);
    }

    function renderSample(p) {
      // The Pro Bundle has no sample track; hide the block entirely.
      // (style.display, not [hidden]: the block's display:grid rule would
      // win over the UA hidden rule.)
      var sampleEl = quiz.querySelector('.ves-quiz__sample');
      if (p.key === 'pro') {
        if (sampleEl) sampleEl.style.display = 'none';
        return;
      }
      if (sampleEl) sampleEl.style.display = '';
      setText('[data-result-sample-title]', 'Try a sample from ' + withArticle(p.name));
      setText('[data-result-sample-desc]', "We'll email you a free sample of " + withArticle(p.name) + ". Drop the assets into a Resolve timeline before you commit.");

      // Sample-track cover: prefer ves.sample_cover (new image metafield),
      // else hide image and use placeholder icon.
      var sampleImg = quiz.querySelector('[data-result-sample-img]');
      var samplePh = quiz.querySelector('[data-result-sample-placeholder]');
      if (p.sampleCover) {
        if (sampleImg) { sampleImg.src = p.sampleCover; sampleImg.alt = p.name + ' free sample'; sampleImg.removeAttribute('hidden'); }
        if (samplePh) samplePh.setAttribute('hidden', '');
      } else {
        if (sampleImg) sampleImg.setAttribute('hidden', '');
        if (samplePh) samplePh.removeAttribute('hidden');
      }

      // Mount the matched bundle's pre-rendered sample form HTML
      // (server-rendered via the shared ves-sample-form-block snippet
      // into the data island) and bind the same direct-POST handler
      // the product page uses. If the bundle has no form-id metafield
      // set, the snippet emits its built-in placeholder.
      var mount = quiz.querySelector('[data-result-sample-mount]');
      if (mount) {
        mount.innerHTML = p.sampleFormHtml || '';
        bindSampleFormSubmit(mount);
        var sampleForm = mount.querySelector('form');
        if (sampleForm) {
          quizMlFields().forEach(function (kv) {
            if (!kv[1]) return;
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'fields[' + kv[0] + ']';
            input.value = kv[1];
            sampleForm.appendChild(input);
          });
          sampleForm.addEventListener('submit', function () {
            logEvent({ t: 'cta', action: 'sample', match: p.name || '' });
          });
        }
      }
    }

    /**
     * One-time per form: wire the direct-POST submit pattern matching
     * sections/ves-sample-form.liquid. Form submits into a hidden
     * iframe so the page doesn't navigate to MailerLite's thank-you;
     * after a ~900ms delay we swap the form for the inline success row.
     * The sample itself is delivered by the MailerLite automation.
     */
    function bindSampleFormSubmit(root) {
      root.querySelectorAll('[data-sample-form]').forEach(function (form) {
        if (form.dataset.vesInit === '1') return;
        form.dataset.vesInit = '1';
        var SUCCESS_DELAY_MS = 900;
        form.addEventListener('submit', function () {
          var btn = form.querySelector('button[type="submit"]');
          if (btn) btn.disabled = true;
          form.setAttribute('data-state', 'loading');
          window.setTimeout(function () {
            var success = form.parentElement.querySelector('[data-sample-success]');
            if (success) success.hidden = false;
            form.hidden = true;
          }, SUCCESS_DELAY_MS);
        });
      });
    }

    // Submit handler is now bound from renderSample → bindSampleFormSubmit()
    // after each mount injection (defined inside this closure above).
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Guard against double-init (multiple section instances on one page).
    if (window.__vesReviewsScrollInit) return;
    window.__vesReviewsScrollInit = true;

    // Intercept any link pointing at #reviews and smooth-scroll the reviews
    // section to viewport center. Deliberately does NOT touch location.hash
    // or fire on page load, so a reload never auto-scrolls to reviews.
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href="#reviews"]');
      if (!link) return;
      var anchor = document.getElementById('reviews');
      if (!anchor) return;
      e.preventDefault();
      var target = anchor.closest('.ves-reviews') || anchor;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        block: 'center',
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    });
  })();

  /* Auto reviews: parse this product's Judge.me widget HTML (inert <template>)
     into our card design. 5-star only, verified badge, body capped at 200
     chars with an ellipsis. The server already hid the section below 3
     qualifying reviews, so this only runs where there are >= 3. */
  (function () {
    if (window.__vesReviewsAutoInit) return;
    window.__vesReviewsAutoInit = true;

    var STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3 7h7l-5.5 4 2 7L12 16l-6.5 4 2-7L2 9h7z"/></svg>';

    function esc(str) {
      var d = document.createElement('div');
      d.textContent = str == null ? '' : str;
      return d.innerHTML;
    }

    function cap(text, n) {
      text = (text || '').replace(/\s+/g, ' ').trim();
      if (text.length <= n) return text;
      var cut = text.slice(0, n);
      var sp = cut.lastIndexOf(' ');
      if (sp > n - 24) cut = cut.slice(0, sp);
      return cut.replace(/[\s.,;:!-]+$/, '') + '\u2026';
    }

    function card(review) {
      var verified = review.getAttribute('data-verified-buyer') === 'true';
      var product = review.getAttribute('data-product-title') || '';
      var authorEl = review.querySelector('.jdgm-rev__author');
      var bodyEl = review.querySelector('.jdgm-rev__body');
      var author = authorEl ? authorEl.textContent.trim() : '';
      var body = bodyEl ? bodyEl.textContent.trim() : '';
      var el = document.createElement('div');
      el.className = 'ves-reviews__card';
      var badge = verified
        ? '<span class="ves-reviews__verified"><svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M7 12.4l3.2 3.2 6.4-6.7" fill="none" stroke="#ffffff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>Verified buyer</span>'
        : '';
      el.innerHTML =
        '<div class="ves-reviews__stars" aria-label="5 out of 5 stars">' + STAR + STAR + STAR + STAR + STAR + '</div>' +
        (body ? '<p class="ves-reviews__text">' + esc(cap(body, 200)) + '</p>' : '') +
        '<div class="ves-reviews__author"><strong>' + esc(author) + '</strong>' + badge +
        (product ? '<div class="ves-reviews__product">on ' + esc(product) + '</div>' : '') +
        '</div>';
      return el;
    }

    document.querySelectorAll('[data-ves-reviews-auto]').forEach(function (grid) {
      if (grid.dataset.vesBuilt) return;
      grid.dataset.vesBuilt = '1';
      var section = grid.closest ? grid.closest('.ves-reviews') : null;
      var tpl = grid.parentNode.querySelector('[data-ves-reviews-source]');
      if (!tpl) return;
      var root = tpl.content || tpl;
      var reviews = root.querySelectorAll('.jdgm-rev');
      var qualifying = [];
      reviews.forEach(function (r) {
        var sc = r.querySelector('[data-score]');
        if (!sc || sc.getAttribute('data-score') !== '5') return;
        var bodyEl = r.querySelector('.jdgm-rev__body');
        var body = bodyEl ? bodyEl.textContent.trim() : '';
        var words = body ? body.split(/\s+/).filter(Boolean).length : 0;
        if (words < 5) return; // skip one-liners with no substance
        qualifying.push({ el: r, len: body.length });
      });
      // Longest review first, descending.
      qualifying.sort(function (a, b) { return b.len - a.len; });
      if (tpl.remove) tpl.remove();
      if (qualifying.length < 3) return; // leave the section hidden
      qualifying.slice(0, 3).forEach(function (q) { grid.appendChild(card(q.el)); });
      if (section) section.classList.remove('ves-reviews--auto-pending');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-sample-form"] && !Shopify.designMode) return;
  try {
    
  /* Direct-POST handler for the VES sample form. The form submits to a hidden
     iframe (so the page doesn't navigate to MailerLite's thank-you), then we
     swap in the inline success message. The sample is delivered by the
     MailerLite automation, not a direct browser redirect. */
  document.querySelectorAll('[data-sample-form]').forEach(function (form) {
    if (form.dataset.vesInit === '1') return;
    form.dataset.vesInit = '1';

    var SUCCESS_DELAY_MS = 900;

    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      form.setAttribute('data-state', 'loading');

      window.setTimeout(function () {
        var success = form.parentElement.querySelector('[data-sample-success]');
        if (success) success.hidden = false;
        form.hidden = true;
      }, SUCCESS_DELAY_MS);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-showcase-shelf"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-ves-shelf]');
    if (!sections.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;

    sections.forEach(function (section) {
      // Reveal: one-shot IntersectionObserver, unobserve after firing.
      // In design mode or reduced motion, show the final state immediately.
      if (reduce || designMode || !('IntersectionObserver' in window)) {
        section.classList.add('is-in');
      } else {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('is-in');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.2 });
        io.observe(section);
      }

      // Scroll-reactive speed boost. Reduced motion keeps the CSS base
      // drift (or static fallback) and skips the rAF entirely.
      if (reduce) return;

      var rowEls = section.querySelectorAll('[data-ves-shelf-row]');
      if (!rowEls.length) return;

      // Per-row drift config: direction and base px/frame.
      var rows = [];
      rowEls.forEach(function (el, idx) {
        var dir = idx === 1 ? -1 : 1;
        var base = idx === 0 ? 0.45 : (idx === 1 ? 0.6 : 0.38);
        rows.push({ el: el, x: 0, dir: dir, base: base, hw: 0 });
      });

      function halfWidth(el) {
        return el.scrollWidth / 2;
      }

      function measure() {
        rows.forEach(function (r) {
          r.hw = halfWidth(r.el);
          r.x = r.dir < 0 ? -r.hw : 0;
        });
      }

      // Hand drift to JS: clear the CSS animation so inline transform wins.
      function takeOver() {
        rows.forEach(function (r) {
          r.el.style.animation = 'none';
        });
        measure();
      }

      var boost = 0;
      var lastScroll = window.scrollY || window.pageYOffset;
      var running = false;

      window.addEventListener('resize', measure, { passive: true });

      window.addEventListener('scroll', function () {
        var cur = window.scrollY || window.pageYOffset;
        var d = cur - lastScroll;
        lastScroll = cur;
        boost += d * 0.5;
        if (boost > 60) boost = 60;
        if (boost < -60) boost = -60;
      }, { passive: true });

      function tick() {
        boost *= 0.9;
        rows.forEach(function (r) {
          if (!r.hw) return;
          r.x -= r.dir * (r.base + Math.abs(boost) * 0.04) + boost * 0.06 * r.dir;
          if (r.x <= -r.hw) r.x += r.hw;
          if (r.x > 0) r.x -= r.hw;
          r.el.style.transform = 'translateX(' + r.x + 'px)';
        });
        requestAnimationFrame(tick);
      }

      // Only animate while the deck is on screen, but take over from CSS
      // on first reveal so the visual is continuous.
      if (designMode) {
        // Theme editor: leave the CSS animation running, no rAF jank.
        return;
      }

      if ('IntersectionObserver' in window) {
        var runIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !running) {
              running = true;
              takeOver();
              requestAnimationFrame(tick);
            }
          });
        }, { threshold: 0 });
        runIo.observe(section);
      } else {
        running = true;
        takeOver();
        requestAnimationFrame(tick);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-solution"] && !Shopify.designMode) return;
  try {
    
  // Feature-card clips ship with preload="none" so they cost nothing at
  // page load; play only while the card is on screen.
  var vesIoVids = document.querySelectorAll('[data-ves-io-video]');
  if (vesIoVids.length && 'IntersectionObserver' in window) {
    var vesVidIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '120px' });
    vesIoVids.forEach(function (v) { vesVidIo.observe(v); });
  } else {
    vesIoVids.forEach(function (v) {
      v.setAttribute('autoplay', '');
      if (v.play) v.play();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__vesStickyCartInit) return;
    window.__vesStickyCartInit = true;

    function init() {
      var bar = document.querySelector('[data-ves-sticky-cart]');
      if (!bar) return;

      var heroSel = bar.dataset.heroSelector || '.ves-hero';
      var hero = document.querySelector(heroSel);
      if (!hero) {
        // No hero on this page → just show the bar after a short scroll.
        var threshold = 320;
        function onScroll() {
          if (window.scrollY > threshold) bar.classList.add('is-visible');
          else bar.classList.remove('is-visible');
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return;
      }

      // Show the bar whenever the hero is OUT of view. Hide when it's in view.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) bar.classList.remove('is-visible');
          else bar.classList.add('is-visible');
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      io.observe(hero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-two-ways"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.ves-tw');

    sections.forEach(function (section) {
      var panels = section.querySelectorAll('.ves-tw__panel');
      panels.forEach(function (panel, i) {
        panel.style.transitionDelay = i * 90 + 'ms';
      });

      // Theme editor: instant-complete so no content stays hidden.
      var designMode = window.Shopify && window.Shopify.designMode;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (designMode || reduce || !('IntersectionObserver' in window)) {
        section.classList.add('is-in');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.25 }
      );

      io.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-youtube-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-ves-yt]');
    if (!roots.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      if (reduce || !('IntersectionObserver' in window)) {
        root.classList.add('is-in');
        return;
      }

      var stage = root.querySelector('[data-ves-yt-stage]') || root;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-in');
            io.disconnect();
          }
        });
      }, { threshold: 0.25 });

      io.observe(stage);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
